import { jsx as i, jsxs as m, Fragment as ae } from "react/jsx-runtime";
import * as Y from "react";
import Fe, { useState as me, useEffect as xe, useId as Tt, useRef as Ae } from "react";
import { ListFilter as At, X as Z, Search as $e, MinusIcon as It, CheckIcon as Yt, CircleAlert as He, Sheet as jt, Presentation as Ft, FileText as Be, FileArchive as $t, MessageCircle as Qe, Music as Ht, Paperclip as Wt, Hourglass as Et, Bell as Ue, CirclePlay as Rt, VideoOff as Vt, VolumeOff as Bt, ZoomIn as Qt, Send as Ut, Square as Kt, Mic as qt, ImageOff as Gt, Upload as Xt, CloudUpload as Jt, RefreshCw as Zt, UserPlus as Ce, PhoneOff as Ke, Phone as qe, BookmarkPlus as er, Clock as Ge, Image as tr, Key as rr, Ellipsis as nr, AudioLines as ar, LogOut as ir, Pencil as sr, MessageSquareText as pt, CloudOff as bt, MicOff as gt, PhoneMissed as or, PhoneIncoming as lr, PhoneOutgoing as cr, PhoneForwarded as dr, LibraryBig as ur, Plus as hr, MousePointerClick as fr, Ban as mr, Trash2 as pr, Pause as br, Settings as gr, ArrowLeft as xr, ArrowRight as vr, ChevronLeft as Xe, ChevronDown as xt, ChevronRight as Ie, ExternalLink as Je, CircleHelp as yr, Info as vt, Download as kr, Check as be, User as yt, Users as wr, LockKeyhole as Nr, TriangleAlert as kt, ConciergeBell as zr, Flower2 as Sr, Film as Dr, Video as Or, Play as Mr, IceCreamCone as Cr, Wine as _r, Mountain as Pr, Gem as Lr, Navigation as Tr, Hotel as Ar, Coffee as Ir, Trees as Yr, Library as jr, MapPin as Fr, MessagesSquare as $r, Mail as Hr, Cloud as Wr, Sofa as Er, Trophy as Rr, Cookie as Vr, GraduationCap as Br, LifeBuoy as Qr, ShoppingBag as Ur, Images as Kr, Rocket as qr, Hand as Gr, ChartColumn as Xr, Bookmark as Jr, PawPrint as Zr, PiggyBank as en, Briefcase as tn, Store as rn, Wallet as nn, Star as an, Lightbulb as sn, ThumbsUp as on, Lock as ln, Heart as cn, ShoppingCart as dn, CircleUser as un, House as hn, ArrowUp as fn, ArrowDown as mn, Loader2 as pn, CircleCheck as bn } from "lucide-react";
import * as Ze from "@radix-ui/react-checkbox";
import gn from "clsx";
import { extendTailwindMerge as xn } from "tailwind-merge";
import { cva as ie } from "class-variance-authority";
import * as _e from "@radix-ui/react-avatar";
import * as T from "@radix-ui/react-dropdown-menu";
import * as Q from "@radix-ui/react-dialog";
import * as j from "@radix-ui/react-popover";
import * as we from "@radix-ui/react-tabs";
import { Calendar as vn } from "react-multi-date-picker";
import * as ge from "@radix-ui/react-tooltip";
import * as et from "@radix-ui/react-switch";
import * as le from "@radix-ui/react-toast";
import * as oa from "@radix-ui/react-context-menu";
import { Branch as Ba } from "@radix-ui/react-dismissable-layer";
const yn = 300;
function la(t, n = yn) {
  const [a, e] = me(!1);
  return xe(() => {
    if (!t) {
      e(!1);
      return;
    }
    const r = setTimeout(() => e(!0), n);
    return () => clearTimeout(r);
  }, [t, n]), a;
}
const kn = {
  text: "rounded-badge",
  avatar: "rounded-control",
  card: "rounded-card"
}, fe = ({ shape: t = "text", className: n = "", style: a }) => /* @__PURE__ */ i(
  "div",
  {
    "aria-hidden": "true",
    "data-skeleton-block": "",
    className: `bg-line motion-safe:animate-skeleton-pulse ${kn[t]} ${n}`,
    style: a
  }
), tt = [62, 48, 70, 55, 41, 66, 52, 44], rt = [44, 58, 40, 50, 63, 46, 54, 68], ca = ({ label: t, rows: n = 8, rowHeight: a = 48, avatar: e = !0, trailing: r = !1, className: s = "" }) => /* @__PURE__ */ i("div", { role: "status", "aria-label": t, "aria-live": "polite", className: `flex w-full flex-col ${s}`, children: Array.from({ length: n }, (l, c) => /* @__PURE__ */ m(
  "div",
  {
    "data-skeleton-row": "",
    className: "flex items-center gap-3 px-4",
    style: { height: a },
    children: [
      e && /* @__PURE__ */ i(fe, { shape: "avatar", className: "size-8 shrink-0" }),
      /* @__PURE__ */ m("div", { className: "flex min-w-0 flex-1 flex-col gap-1.5", children: [
        /* @__PURE__ */ i(fe, { className: "h-2.5", style: { width: `${tt[c % tt.length]}%` } }),
        /* @__PURE__ */ i(fe, { className: "h-2", style: { width: `${rt[c % rt.length]}%` } })
      ] }),
      r && /* @__PURE__ */ i(fe, { className: "h-2 w-9 shrink-0" })
    ]
  },
  c
)) }), nt = [1, 0.8, 1, 0.9, 0.85, 1, 0.8, 0.95], da = ({ label: t, rows: n = 10, rowHeight: a = 44, gridTemplateColumns: e, cells: r, className: s = "" }) => /* @__PURE__ */ i("div", { role: "status", "aria-label": t, "aria-live": "polite", className: s, children: Array.from({ length: n }, (l, c) => /* @__PURE__ */ i(
  "div",
  {
    "data-skeleton-row": "",
    className: "grid items-center border-b border-solid border-line px-2",
    style: { height: a, gridTemplateColumns: e },
    children: r.map((d, u) => /* @__PURE__ */ m("span", { className: "flex items-center gap-2.5", children: [
      (d == null ? void 0 : d.avatar) && /* @__PURE__ */ i(fe, { shape: "avatar", className: "size-7 shrink-0 !rounded-chip" }),
      d && /* @__PURE__ */ i(fe, { className: "h-2.5", style: { width: Math.round(d.width * nt[c % nt.length]) } })
    ] }, u))
  },
  c
)) }), ua = ({ count: t, onClick: n, label: a = "Filters", iconOnly: e = !1, className: r = "" }) => {
  const s = t > 0, l = s ? `${a}, ${t} active` : a;
  return /* @__PURE__ */ m(
    "button",
    {
      type: "button",
      "aria-label": l,
      "aria-pressed": s,
      onClick: n,
      className: `inline-flex shrink-0 cursor-pointer items-center rounded-control text-callout focus-visible:outline focus-visible:outline-2 focus-visible:outline-brand-focus ${e ? "relative size-control-md justify-center border-0" : "h-control-md gap-1.5 px-3 border border-solid"} ${e && !s ? "bg-transparent text-ink-secondary hover:bg-surface-muted" : s ? "bg-brand-tint text-brand-ink border-brand-disabled" : "bg-surface text-ink border-fill-subtle hover:bg-surface-muted"} ${r}`,
      children: [
        /* @__PURE__ */ i(At, { size: 18, "aria-hidden": "true", className: "!p-0 !text-current" }),
        !e && /* @__PURE__ */ i("span", { children: a }),
        s && /* @__PURE__ */ i(
          "span",
          {
            "aria-hidden": "true",
            "data-filter-count": "",
            className: `inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-brand px-[5px] text-micro text-white ${e ? "absolute -right-1 -top-1" : ""}`,
            children: t
          }
        )
      ]
    }
  );
}, ha = ({ chips: t, onClearAll: n, clearAllLabel: a = "Clear all", className: e = "" }) => t.length === 0 ? null : /* @__PURE__ */ m("div", { role: "group", "aria-label": "Active filters", className: `flex flex-wrap items-center gap-1.5 ${e}`, children: [
  t.map((r) => /* @__PURE__ */ m(
    "span",
    {
      "data-filter-chip": "",
      className: "inline-flex h-7 shrink-0 items-center gap-0.5 whitespace-nowrap rounded-chip bg-brand-tint pl-2.5 pr-1 text-caption text-brand-ink",
      children: [
        r.label,
        /* @__PURE__ */ i(
          "button",
          {
            type: "button",
            "aria-label": `Remove filter ${r.label}`,
            onClick: r.onRemove,
            className: "inline-flex size-6 cursor-pointer items-center justify-center rounded-badge hover:bg-brand-disabled focus-visible:outline focus-visible:outline-2 focus-visible:outline-brand-focus",
            children: /* @__PURE__ */ i(Z, { size: 14, "aria-hidden": "true", className: "!p-0 !text-current" })
          }
        )
      ]
    },
    r.key
  )),
  /* @__PURE__ */ i(
    "button",
    {
      type: "button",
      onClick: n,
      className: "h-7 cursor-pointer whitespace-nowrap px-1.5 text-caption text-ink-muted hover:text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-brand-focus",
      children: a
    }
  )
] }), wn = ({ count: t, label: n, className: a = "" }) => /* @__PURE__ */ i(
  "span",
  {
    "aria-label": n,
    "aria-hidden": n ? void 0 : !0,
    role: n ? "img" : void 0,
    className: `inline-flex h-5 min-w-5 shrink-0 items-center justify-center rounded-full bg-brand px-1.5 text-micro text-white ${a}`,
    children: t > 99 ? "99+" : t
  }
), Nn = {
  success: "bg-success-tint text-success-ink",
  danger: "bg-danger-tint text-danger-ink",
  warning: "bg-warning-tint text-warning-ink",
  brand: "bg-brand-tint text-brand-ink",
  neutral: "bg-surface-muted text-ink-muted-strong"
}, fa = ({ tone: t, children: n, icon: a, className: e = "" }) => /* @__PURE__ */ m("span", { className: `inline-flex h-5 shrink-0 items-center gap-1 whitespace-nowrap rounded-badge px-[7px] text-micro ${a ? "pl-[5px]" : ""} ${Nn[t]} ${e}`, children: [
  a,
  n
] }), ma = ({ logo: t, children: n, footer: a, className: e = "" }) => /* @__PURE__ */ m(
  "nav",
  {
    "aria-label": "Main",
    className: `flex h-full w-nav-rail shrink-0 flex-col items-center gap-2 bg-nav-bg pb-3.5 pt-3 shadow-[inset_-1px_0_0_var(--nav-hover)] ${e}`,
    children: [
      t && /* @__PURE__ */ i("div", { className: "mb-2", children: t }),
      n,
      /* @__PURE__ */ i("div", { className: "flex-1" }),
      a
    ]
  }
), pa = ({ children: t }) => /* @__PURE__ */ i("div", { "aria-hidden": "true", className: "flex size-9 items-center justify-center overflow-hidden rounded-control bg-logo-tile", children: t }), zn = (t) => `group relative flex size-9 shrink-0 cursor-pointer items-center justify-center rounded-[12px] outline-none focus-visible:ring-2 focus-visible:ring-brand-focus ${t ? "bg-nav-active-bg text-nav-icon-active" : "text-nav-icon hover:bg-nav-hover"}`, ba = ({ label: t, icon: n, active: a = !1, onClick: e, render: r, badge: s = 0, badgeLabel: l }) => {
  const c = Tt(), d = s > 0, u = d && !!l, p = /* @__PURE__ */ m(ae, { children: [
    n,
    d && /* @__PURE__ */ i("span", { "data-testid": "nav-rail-badge", className: "pointer-events-none absolute -right-2 -top-1.5", children: /* @__PURE__ */ i(wn, { count: s, className: "ring-2 ring-nav-bg" }) }),
    u && /* @__PURE__ */ i("span", { id: c, hidden: !0, children: l }),
    /* @__PURE__ */ i(
      "span",
      {
        "aria-hidden": "true",
        className: "pointer-events-none absolute left-full z-50 ml-2 whitespace-nowrap rounded-chip bg-inverse-surface px-2 py-1 text-caption text-white opacity-0 shadow-menu transition-opacity group-hover:opacity-100 group-hover:delay-300 group-focus-visible:opacity-100",
        children: t
      }
    )
  ] }), g = {
    className: zn(a),
    "aria-label": t,
    "aria-current": a ? "page" : void 0,
    ...u && { "aria-describedby": c },
    children: p
  };
  return r ? /* @__PURE__ */ i(ae, { children: r(g) }) : /* @__PURE__ */ i("button", { type: "button", onClick: e, ...g });
}, ga = ({ label: t, title: n, action: a, children: e, className: r = "" }) => /* @__PURE__ */ m(
  "section",
  {
    "aria-label": t,
    className: `flex h-full w-panel shrink-0 flex-col border-0 border-r border-solid border-line bg-surface ${r}`,
    children: [
      (n || a) && /* @__PURE__ */ m("div", { className: "flex h-header shrink-0 items-center justify-between px-4", children: [
        typeof n == "string" ? /* @__PURE__ */ i("h2", { className: "m-0 text-title text-ink", children: n }) : n,
        a
      ] }),
      e
    ]
  }
), xa = ({ children: t, className: n = "" }) => /* @__PURE__ */ i("header", { className: `flex h-header shrink-0 items-center gap-3 border-0 border-b border-solid border-line px-4 ${n}`, children: t });
function va({ options: t, value: n, onChange: a, label: e, onCanvas: r = !1, fullWidth: s = !1, className: l = "" }) {
  const c = Ae([]), d = (u, p) => {
    var y;
    if (u.key !== "ArrowRight" && u.key !== "ArrowLeft") return;
    u.preventDefault();
    const g = u.key === "ArrowRight" ? 1 : -1, f = (p + g + t.length) % t.length;
    a(t[f].id), (y = c.current[f]) == null || y.focus();
  };
  return /* @__PURE__ */ i(
    "div",
    {
      role: "tablist",
      "aria-label": e,
      className: `flex rounded-control p-[3px] ${r ? "bg-line" : "bg-surface-muted"} ${s ? "w-full" : "w-fit"} ${l}`,
      children: t.map((u, p) => {
        const g = u.id === n;
        return /* @__PURE__ */ i(
          "button",
          {
            ref: (f) => {
              c.current[p] = f;
            },
            type: "button",
            role: "tab",
            "aria-selected": g,
            tabIndex: g ? 0 : -1,
            onClick: () => a(u.id),
            onKeyDown: (f) => d(f, p),
            className: `flex h-[30px] cursor-pointer items-center justify-center whitespace-nowrap rounded-chip px-3.5 text-footnote outline-none focus-visible:ring-2 focus-visible:ring-brand-focus ${s ? "flex-1" : ""} ${g ? "bg-segment-selected font-semibold text-ink shadow-segment" : "font-medium text-ink-muted-strong hover:text-ink"}`,
            children: u.label
          },
          u.id
        );
      })
    }
  );
}
const ya = ({ value: t, onChange: n, label: a, placeholder: e = "Search…", className: r = "", autoFocus: s }) => /* @__PURE__ */ m("label", { className: `flex h-control-md items-center gap-2 rounded-control bg-surface-muted px-3 hover:bg-line focus-within:ring-2 focus-within:ring-brand-focus ${r}`, children: [
  /* @__PURE__ */ i($e, { size: 16, "aria-hidden": "true", className: "!p-0 shrink-0 !text-ink-muted" }),
  /* @__PURE__ */ i(
    "input",
    {
      type: "search",
      value: t,
      onChange: (l) => n(l.target.value),
      placeholder: e,
      "aria-label": a,
      autoFocus: s,
      className: "min-w-0 flex-1 border-0 bg-transparent p-0 text-callout text-ink outline-none placeholder:text-ink-muted focus:ring-0 [&::-webkit-search-cancel-button]:hidden"
    }
  ),
  t && /* @__PURE__ */ i(
    "button",
    {
      type: "button",
      "aria-label": "Clear search",
      onClick: () => n(""),
      className: "inline-flex size-5 shrink-0 cursor-pointer items-center justify-center rounded-full bg-fill-subtle text-ink-secondary",
      children: /* @__PURE__ */ i(Z, { size: 12, "aria-hidden": "true", className: "!p-0 !text-current" })
    }
  )
] }), Sn = {
  20: "size-5 rounded-badge text-micro",
  28: "size-7 rounded-chip text-micro",
  32: "size-8 rounded-control text-micro",
  // Nav rail (the signed-in user).
  36: "size-9 rounded-control text-footnote",
  40: "size-10 rounded-[12px] text-[14px]",
  48: "size-12 rounded-[12px] text-[18px]",
  64: "size-16 rounded-sheet text-[24px]",
  128: "size-32 rounded-[28px] text-[36px]"
}, at = ["violet", "blue", "orange", "green", "pink", "neutral"], Dn = {
  violet: "bg-avatar-violet-bg text-avatar-violet-fg",
  blue: "bg-avatar-blue-bg text-avatar-blue-fg",
  orange: "bg-avatar-orange-bg text-avatar-orange-fg",
  green: "bg-avatar-green-bg text-avatar-green-fg",
  pink: "bg-avatar-pink-bg text-avatar-pink-fg",
  neutral: "bg-avatar-neutral-bg text-avatar-neutral-fg"
};
function We(t) {
  let n = 0;
  for (const a of t.trim().toLowerCase())
    n = n * 31 + a.charCodeAt(0) | 0;
  return at[Math.abs(n) % (at.length - 1)];
}
function On(t) {
  const n = t.trim().split(/\s+/).filter((r) => /[\p{L}\p{N}]/u.test(r));
  if (n.length === 0) return "";
  const a = n[0][0], e = n.length > 1 ? n[n.length - 1][0] : "";
  return (a + e).toUpperCase();
}
const ka = ({ name: t = "", src: n, icon: a, palette: e, size: r = 32, badge: s, className: l = "" }) => {
  const c = Dn[e ?? (a && !t ? "neutral" : We(t))];
  return /* @__PURE__ */ m("span", { "aria-hidden": "true", className: `relative inline-flex shrink-0 ${l}`, children: [
    /* @__PURE__ */ i("span", { className: `inline-flex items-center justify-center overflow-hidden font-semibold ${Sn[r]} ${n ? "" : c}`, children: n ? /* @__PURE__ */ i("img", { src: n, alt: "", className: "size-full object-cover" }) : a ?? On(t) }),
    s && /* @__PURE__ */ i("span", { className: "absolute -bottom-1 -right-1", children: s })
  ] });
}, Mn = xn({
  extend: {
    classGroups: {
      "font-size": [{ text: ["display", "avatar-xl", "headline", "title", "body", "body-strong", "callout", "footnote", "caption", "micro"] }]
    }
  }
}), Cn = (...t) => Mn(gn(...t));
function v(...t) {
  return Cn(...t);
}
function wa({
  label: t,
  value: n,
  checked: a,
  onCheckedChange: e,
  defaultChecked: r,
  theme: s = "light",
  className: l,
  ...c
}) {
  const d = Y.useId();
  return /* @__PURE__ */ m("div", { className: "flex items-center", children: [
    /* @__PURE__ */ i(
      Ze.Root,
      {
        id: d,
        "data-slot": "checkbox",
        checked: a === "indeterminate" ? "indeterminate" : !!a,
        onCheckedChange: e,
        value: n,
        defaultChecked: r,
        className: v(
          // DS checkbox: 16px, radius 4, fill-subtle border, brand when checked.
          "peer box-border size-4 shrink-0 cursor-pointer rounded-[4px] border border-solid border-fill-subtle bg-surface p-0 outline-none transition-colors",
          "data-[state=checked]:border-brand data-[state=checked]:bg-brand data-[state=indeterminate]:border-brand data-[state=indeterminate]:bg-brand",
          "focus-visible:ring-2 focus-visible:ring-brand-focus focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50",
          l
        ),
        ...c,
        children: /* @__PURE__ */ m(
          Ze.Indicator,
          {
            "data-slot": "checkbox-indicator",
            className: "flex items-center justify-center text-current transition-none",
            children: [
              a === "indeterminate" && /* @__PURE__ */ i(It, { className: "size-3.5 !text-white !p-0" }),
              a === !0 && /* @__PURE__ */ i(Yt, { className: "size-3.5 !text-white !p-0" })
            ]
          }
        )
      }
    ),
    !!t && /* @__PURE__ */ i("label", { htmlFor: d, className: "cursor-pointer pl-3 text-callout text-ink", children: t })
  ] });
}
const _n = ie(
  "box-border inline-flex border border-solid items-center [&_svg]:!p-0 [&_svg]:shrink-0 [&_svg]:!text-current justify-center gap-1.5 whitespace-nowrap rounded-control text-callout font-medium transition-colors duration-150 disabled:pointer-events-none outline-none focus-visible:ring-2 focus-visible:ring-brand-focus focus-visible:ring-offset-2 cursor-pointer [&_svg]:!p-0 [&_svg]:shrink-0 [&_svg]:!text-current",
  {
    variants: {
      variant: {
        primary: "bg-brand border-brand text-white hover:bg-brand-hover hover:border-brand-hover active:bg-brand-pressed disabled:bg-brand-disabled disabled:border-brand-disabled",
        secondary: "bg-surface border-fill-subtle text-ink hover:bg-surface-muted active:bg-line disabled:bg-surface-muted disabled:text-ink-disabled",
        tertiary: "bg-surface-muted border-transparent text-ink-secondary hover:bg-line disabled:text-ink-disabled [&.active]:bg-brand-tint [&.active]:text-brand-ink",
        "secondary-contrast": "bg-transparent border-transparent text-ink-muted hover:bg-surface-muted hover:text-ink disabled:text-ink-disabled",
        danger: "bg-danger border-danger text-white hover:bg-danger-hover hover:border-danger-hover disabled:opacity-60",
        "danger-secondary": "bg-surface border-fill-subtle text-danger-ink hover:bg-danger-tint disabled:text-ink-disabled",
        /** Text-only link actions ("Add more", "Remove"). */
        text: "bg-transparent border-transparent text-brand-ink hover:bg-brand-tint disabled:text-ink-disabled",
        "text-danger": "bg-transparent border-transparent text-danger-ink hover:bg-danger-tint disabled:text-ink-disabled"
      },
      size: {
        default: "h-control-md px-3.5",
        sm: "h-control-sm px-3 text-footnote",
        lg: "h-control-lg px-5",
        icon: "size-control-md p-0",
        iconXs: "size-5 p-0 text-footnote"
      }
    },
    defaultVariants: {
      variant: "primary",
      size: "default"
    }
  }
), ze = Fe.forwardRef(
  function({
    children: n,
    variant: a = "primary",
    size: e = "default",
    disabled: r = !1,
    onClick: s,
    className: l = "",
    style: c = {},
    loading: d = !1,
    ...u
  }, p) {
    return /* @__PURE__ */ i(
      "button",
      {
        ref: p,
        className: v(_n({ variant: a, size: e }), d && "relative", l),
        style: c,
        disabled: r || d,
        "aria-busy": d || void 0,
        onClick: s,
        ...u,
        children: d ? /* @__PURE__ */ m(ae, { children: [
          /* @__PURE__ */ i("span", { className: "invisible inline-flex items-center gap-1.5", children: n }),
          /* @__PURE__ */ i("span", { "aria-hidden": "true", className: "absolute inline-block size-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent" }),
          /* @__PURE__ */ i("span", { className: "sr-only", children: "Loading" })
        ] }) : n
      }
    );
  }
), Na = Y.forwardRef(function({
  className: n,
  type: a,
  label: e,
  labelClassName: r,
  error: s,
  id: l,
  prefixIcon: c,
  suffixIcon: d,
  onClear: u,
  containerClassName: p,
  ...g
}, f) {
  const y = Y.useId(), N = l || (e ? `input-${y}` : void 0), z = !!u && !!g.value, b = typeof s == "string" ? s : void 0;
  return /* @__PURE__ */ m("div", { className: v("flex flex-col gap-1.5", p), children: [
    e && /* @__PURE__ */ i(
      "label",
      {
        htmlFor: N,
        className: v(
          "text-footnote font-medium text-ink-secondary peer-disabled:cursor-not-allowed",
          r
        ),
        children: e
      }
    ),
    /* @__PURE__ */ m("div", { className: "relative", children: [
      c && /* @__PURE__ */ i("span", { className: "pointer-events-none absolute left-3 top-1/2 flex -translate-y-1/2 items-center text-ink-muted", children: c }),
      /* @__PURE__ */ i(
        "input",
        {
          ref: f,
          id: N,
          type: a,
          "data-slot": "input",
          "aria-invalid": !!s,
          className: v(
            // Design System input: 36px, radius 10, 1px fill-subtle border, 2px brand-focus ring.
            "flex h-control-md w-full min-w-0 rounded-control border border-solid border-fill-subtle bg-surface px-3 py-1 text-callout text-ink transition-colors",
            "file:border-0 file:bg-transparent file:text-footnote file:font-medium",
            "placeholder:text-ink-muted",
            "disabled:cursor-not-allowed disabled:bg-surface-muted disabled:text-ink-disabled",
            "outline-none ring-0 focus:outline-none focus:ring-2 focus:ring-brand-focus focus:border-transparent",
            "aria-invalid:border-danger-ink aria-invalid:focus:ring-danger-ink",
            c && "pl-9",
            (d || z) && "pr-9",
            n
          ),
          ...g
        }
      ),
      z && /* @__PURE__ */ i(
        "button",
        {
          type: "button",
          "aria-label": "Clear",
          onClick: u,
          className: "absolute right-2 top-1/2 box-border flex size-6 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full border-0 bg-transparent p-0 text-ink-muted hover:bg-surface-muted hover:text-ink",
          children: /* @__PURE__ */ i(Z, { size: 14, "aria-hidden": "true", className: "!p-0 !text-current" })
        }
      ),
      d && !z && /* @__PURE__ */ i("span", { className: "absolute right-3 top-1/2 flex -translate-y-1/2 items-center text-ink-muted", children: d })
    ] }),
    b && /* @__PURE__ */ m("p", { role: "alert", className: "m-0 flex items-center gap-1 text-footnote text-danger-ink", children: [
      /* @__PURE__ */ i(He, { size: 14, "aria-hidden": "true", className: "!p-0 shrink-0 !text-current" }),
      b
    ] })
  ] });
}), Pn = ({ className: t }) => /* @__PURE__ */ i(
  "svg",
  {
    viewBox: "0 0 24 24",
    className: t,
    fill: "currentColor",
    stroke: "white",
    "aria-hidden": "true",
    children: /* @__PURE__ */ i("path", { d: "M21.5 12a9.5 9.5 0 11-9.5-9.5 7.5 7.5 0 009.5 9.5z" })
  }
), Ln = {
  // Group / number icons users pick from.
  home: hn,
  account_circle: un,
  shopping_cart: dn,
  favorite: cn,
  lock: ln,
  thumb_up: on,
  lightbulb: sn,
  star: an,
  account_balance_wallet: nn,
  store: rn,
  work: tn,
  savings: en,
  pets: Zr,
  bookmark: Jr,
  leaderboard: Xr,
  pan_tool: Gr,
  rocket_launch: qr,
  perm_media: Kr,
  shopping_bag: Ur,
  contact_support: Qr,
  notifications: Ue,
  school: Br,
  cookie: Vr,
  sports_football: Rr,
  weekend: Er,
  cloud: Wr,
  email: Hr,
  forum: $r,
  chat_bubble: Qe,
  place: Fr,
  local_library: jr,
  park: Yr,
  local_cafe: Ir,
  hotel: Ar,
  navigation: Tr,
  diamond: Lr,
  terrain: Pr,
  wine_bar: _r,
  icecream: Cr,
  play_arrow: Mr,
  videocam: Or,
  movie: Dr,
  spa: Sr,
  room_service: zr,
  warning: kt,
  visibility_lock: Nr,
  group: wr,
  person: yt,
  call: qe,
  // Interface icons.
  check: be,
  done: be,
  close: Z,
  download: kr,
  info: vt,
  error: He,
  question_mark: yr,
  description: Be,
  open_in_new: Je,
  launch: Je,
  keyboard_arrow_right: Ie,
  chevron_right: Ie,
  keyboard_arrow_down: xt,
  chevron_left: Xe,
  arrow_back_ios: Xe,
  arrow_forward: vr,
  arrow_back: xr,
  schedule: Ge,
  settings: gr,
  search: $e,
  pause: br,
  group_add: Ce,
  delete: pr,
  block: mr,
  ads_click: fr,
  add: hr,
  library_add: ur,
  phone_disabled: Ke,
  phone_forwarded: dr,
  call_made: cr,
  call_received: lr,
  call_missed: or,
  mic_off: gt,
  cloud_off: bt,
  "message-square-text": pt,
  edit: sr,
  exit_to_app: ir,
  graphic_eq: ar,
  more_horiz: nr,
  person_add_alt: Ce,
  key: rr,
  image: tr,
  pending: Ge,
  bookmark_add: er,
  // Chat media and players.
  phone: qe,
  call_end: Ke,
  person_add: Ce,
  refresh: Zt,
  cloud_upload: Jt,
  upload: Xt,
  broken_image: Gt,
  mic: qt,
  stop: Kt,
  send: Ut,
  zoom_in: Qt,
  volume_off: Bt,
  videocam_off: Vt,
  play_circle_filled: Rt,
  notifications_none: Ue,
  hourglass_empty: Et,
  attachment: Wt,
  audiotrack: Ht,
  chat: Qe,
  folder_zip: $t,
  picture_as_pdf: Be,
  slideshow: Ft,
  table_chart: jt
};
function Tn({ name: t, size: n = 16, className: a, fallback: e }) {
  const r = t && Ln[t] || e;
  return r ? /* @__PURE__ */ i(r, { size: n, "aria-hidden": "true", className: v("!p-0 shrink-0", a) }) : null;
}
const Ye = ie(
  "relative flex shrink-0 rounded-2xl",
  {
    variants: {
      size: {
        // Design System radii: a rounded square that scales with the size, never a circle.
        "14px": "size-4 rounded-[4px]",
        "20px": "size-5 rounded-badge",
        "24px": "size-6 rounded-badge",
        "28px": "size-7 rounded-chip",
        "32px": "size-8 rounded-control",
        "40px": "size-10 rounded-[12px]",
        "64px": "size-16 rounded-sheet",
        "128px": "size-32 rounded-[28px]",
        "300px": "size-[300px] rounded-4xl",
        default: "size-8 rounded-control"
      }
    },
    defaultVariants: {
      size: "default"
    }
  }
), An = ie(
  "absolute flex items-center justify-center text-orange-500",
  {
    variants: {
      size: {
        "14px": "size-1.5 -bottom-0 -right-0",
        "20px": "size-2 -bottom-0 -right-0",
        "24px": "size-2 -bottom-0 -right-0",
        "28px": "size-2.5 -bottom-0 -right-0",
        "32px": "size-3 -bottom-0.5 -right-0.5",
        "40px": "size-3.5 -bottom-0.5 -right-0.5",
        "64px": "size-5 -bottom-1 -right-1",
        "128px": "size-7 -bottom-1.5 -right-1.5",
        "300px": "size-14 -bottom-3 -right-3",
        default: "size-3 -bottom-0.5 -right-0.5"
      }
    },
    defaultVariants: {
      size: "default"
    }
  }
), In = ie(
  "absolute rounded-full border-surface bg-current",
  {
    variants: {
      size: {
        "14px": "size-1.5 -bottom-0 -right-0 border-[1px]",
        "20px": "size-2 -bottom-0 -right-0 border-[1px]",
        "24px": "size-2 -bottom-0 -right-0 border-[1px]",
        "28px": "size-2.5 -bottom-0 -right-0 border-[1px]",
        "32px": "size-3 -bottom-0.5 -right-0.5 border-2",
        "40px": "size-3.5 -bottom-0.5 -right-0.5 border-2",
        "64px": "size-5 -bottom-1 -right-1 border-2",
        "128px": "size-7 -bottom-1.5 -right-1.5 border-[3px]",
        "300px": "size-14 -bottom-3 -right-3 border-[4px]",
        default: "size-3 -bottom-0.5 -right-0.5 border-2"
      },
      status: {
        ONLINE: "text-success",
        TALKING: "text-status-away",
        OFFLINE: "text-status-offline",
        DND: "text-status-dnd",
        UNKNOWN: "text-status-offline"
      }
    },
    defaultVariants: {
      size: "default",
      status: "UNKNOWN"
    }
  }
), Yn = ie(
  "flex size-full items-center justify-center font-semibold",
  {
    variants: {
      size: {
        "14px": "text-[6px] rounded-[4px] size-4",
        "20px": "text-[9px] rounded-badge size-5",
        "24px": "text-[10px] rounded-badge size-6",
        "28px": "text-micro rounded-chip size-7",
        "32px": "text-micro rounded-control size-8",
        "40px": "text-[14px] rounded-[12px] size-10",
        "64px": "text-[24px] rounded-sheet size-16",
        "128px": "text-[36px] rounded-[28px] size-32",
        "300px": "text-8xl rounded-4xl size-[300px]",
        default: "text-micro rounded-control size-8"
      }
    },
    defaultVariants: {
      size: "default"
    }
  }
), jn = {
  ONLINE: "ONLINE",
  TALKING: "TALKING",
  OFFLINE: "OFFLINE",
  DND: "DND",
  UNKNOWN: "UNKNOWN"
}, Fn = (t) => {
  var r, s;
  if (!t) return "";
  const n = t.split(" "), a = ((r = n[0]) == null ? void 0 : r.charAt(0).toUpperCase()) || "", e = ((s = n[n.length - 1]) == null ? void 0 : s.charAt(0).toUpperCase()) || "";
  return a + (n.length > 1 ? e : "");
}, wt = {
  "14px": 9,
  "20px": 12,
  "24px": 14,
  "28px": 16,
  "32px": 18,
  "40px": 20,
  "64px": 32,
  "128px": 56,
  "300px": 120,
  default: 18
}, $n = {
  violet: "bg-avatar-violet-bg text-avatar-violet-fg",
  blue: "bg-avatar-blue-bg text-avatar-blue-fg",
  orange: "bg-avatar-orange-bg text-avatar-orange-fg",
  green: "bg-avatar-green-bg text-avatar-green-fg",
  pink: "bg-avatar-pink-bg text-avatar-pink-fg",
  neutral: "bg-avatar-neutral-bg text-avatar-neutral-fg"
};
function it({
  size: t = "default",
  type: n = "default",
  src: a,
  name: e,
  status: r,
  dnd: s = !1,
  className: l,
  children: c,
  colorFromName: d = !0,
  icon: u,
  palette: p,
  ...g
}) {
  const [f, y] = me(r), [N, z] = me(a);
  xe(() => {
    y(s ? jn.DND : r);
  }, [s, r]), xe(() => {
    z(a);
  }, [a]);
  const b = Fn(e), x = $n[p ?? (d && !!e && !u ? We(e) : "neutral")], k = wt[t ?? "default"];
  return /* @__PURE__ */ m(
    _e.Root,
    {
      className: Ye({ size: t, className: l }) + " overflow-visible",
      ...g,
      children: [
        /* @__PURE__ */ i(
          _e.Image,
          {
            src: N || "",
            alt: e || "Avatar",
            className: Ye({ size: t }) + " aspect-square size-full object-cover "
          }
        ),
        /* @__PURE__ */ i(
          _e.Fallback,
          {
            className: Yn({ size: t }) + " " + x,
            children: u ?? (b || /* @__PURE__ */ i(yt, { size: k, "aria-hidden": "true", className: "!p-0 !text-current" }))
          }
        ),
        f === "DND" ? /* @__PURE__ */ i("div", { className: An({ size: t }), children: /* @__PURE__ */ i(Pn, { className: "w-full h-full block" }) }) : f ? /* @__PURE__ */ i("div", { className: In({ size: t, status: f }) }) : null,
        c
      ]
    }
  );
}
const Hn = {
  "14px": {
    offsetX: 10,
    offsetY: 5,
    statusSize: 6,
    statusOffset: -6
  },
  "20px": {
    offsetX: 17,
    // Horizontal offset for back avatar
    offsetY: 10,
    // Vertical offset for front avatar
    statusSize: 8,
    // Status dot size
    statusOffset: -8
    // Status dot position offset
  },
  "24px": {
    offsetX: 18,
    offsetY: 12,
    statusSize: 8,
    statusOffset: -12
  },
  "28px": {
    offsetX: 14,
    offsetY: 15,
    statusSize: 10,
    statusOffset: -14
  },
  "32px": {
    offsetX: 16,
    offsetY: 20,
    statusSize: 12,
    statusOffset: -16
  },
  "40px": {
    offsetX: 20,
    offsetY: 21,
    statusSize: 14,
    statusOffset: -20
  },
  "64px": {
    offsetX: 32,
    offsetY: 34,
    statusSize: 16,
    statusOffset: -32
  },
  "128px": {
    offsetX: 64,
    offsetY: 65,
    statusSize: 24,
    statusOffset: -64
  },
  "300px": {
    offsetX: 150,
    offsetY: 152,
    statusSize: 40,
    statusOffset: -150
  },
  default: {
    offsetX: 16,
    offsetY: 20,
    statusSize: 12,
    statusOffset: -16
  }
}, za = ({ users: t, size: n = "default", showStatus: a = !1 }) => {
  if (!t || t.length === 0) return null;
  const [e, r] = t, s = Hn[n];
  return /* @__PURE__ */ m("div", { className: "relative inline-block", children: [
    r && /* @__PURE__ */ i(
      "div",
      {
        className: "absolute",
        style: {
          top: "0px",
          left: `${s.offsetX}px`,
          zIndex: 1
        },
        children: /* @__PURE__ */ i(
          it,
          {
            name: r.displayName,
            src: r.avatarUrl,
            size: n,
            className: "border-white border-2 box-content"
          }
        )
      }
    ),
    /* @__PURE__ */ i(
      "div",
      {
        className: "relative ",
        style: {
          top: `${s.offsetY}px`,
          left: "0px",
          zIndex: 2
        },
        children: /* @__PURE__ */ i(
          it,
          {
            name: e.displayName,
            src: e.avatarUrl,
            size: n,
            className: "border-white border-2 box-content"
          }
        )
      }
    ),
    a && /* @__PURE__ */ i(
      "div",
      {
        className: "absolute bg-green-500 rounded-full",
        style: {
          width: `${s.statusSize}px`,
          height: `${s.statusSize}px`,
          bottom: `${s.statusOffset}px`,
          right: `${s.statusOffset}px`,
          zIndex: 3
        }
      }
    )
  ] });
}, J = {
  blue: "bg-tile-blue",
  orange: "bg-tile-orange",
  pink: "bg-tile-pink",
  violet: "bg-tile-violet",
  green: "bg-tile-green",
  neutral: "bg-tile-neutral",
  teal: "bg-tile-teal",
  red: "bg-tile-red"
}, st = {
  blue: "blue",
  orange: "orange",
  yellow: "orange",
  lightYellow: "orange",
  pink: "pink",
  red: "red",
  purple: "violet",
  violet: "violet",
  green: "green",
  teal: "teal",
  graphite: "neutral",
  slate: "neutral",
  grey: "neutral",
  darkGrey: "neutral",
  default: "neutral",
  zinc: "neutral",
  disabled: "neutral"
};
function Wn(t, n) {
  return t && st[t] ? st[t] : n ? We(n) : "neutral";
}
const Sa = [
  { key: "blue", label: "Blue", className: J.blue },
  { key: "orange", label: "Orange", className: J.orange },
  { key: "pink", label: "Pink", className: J.pink },
  { key: "purple", label: "Purple", className: J.violet },
  { key: "green", label: "Green", className: J.green },
  { key: "graphite", label: "Slate", className: J.neutral },
  { key: "red", label: "Red", className: J.red }
];
function Da({ icon: t, color: n, name: a, size: e = "default", disabled: r, className: s, onClick: l }) {
  const c = J[r || n === "disabled" ? "neutral" : Wn(n, a)];
  return /* @__PURE__ */ i("span", { onClick: l, "aria-hidden": "true", className: v(Ye({ size: e }), c, "text-white", r && "opacity-50", s, "items-center justify-center"), children: /* @__PURE__ */ i(Tn, { name: t, size: wt[e ?? "default"], className: "!text-current" }) });
}
const ve = "z-[70] min-w-[200px] overflow-hidden rounded-xl bg-zinc-950 p-1 text-white shadow-menu outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95", ye = "group relative flex min-h-9 cursor-pointer select-none items-center gap-2.5 rounded-chip px-2.5 text-callout font-medium text-white outline-none data-[highlighted]:bg-zinc-800 data-[state=open]:bg-zinc-800 data-[disabled]:cursor-default data-[disabled]:text-zinc-500";
function De({
  trigger: t,
  children: n,
  open: a,
  onOpenChange: e,
  align: r = "end",
  side: s = "bottom",
  showCloseIcon: l = !1,
  sideOffset: c = 6,
  contentClassName: d,
  ...u
}) {
  const [p, g] = Fe.useState(!1), f = (b) => {
    g(b), e == null || e(b);
  }, y = a !== void 0 ? a : p, z = l ? /* @__PURE__ */ m("div", { className: "relative inline-block", children: [
    /* @__PURE__ */ i("div", { className: `transition-opacity duration-200 ${y ? "opacity-0" : "opacity-100"}`, children: t }),
    /* @__PURE__ */ i("div", { className: `absolute inset-0 flex items-center justify-center transition-opacity duration-200 ${y ? "opacity-100" : "pointer-events-none opacity-0"}`, children: /* @__PURE__ */ i(Z, { size: 28, className: "!p-1 rounded-lg bg-zinc-900 !text-white" }) })
  ] }) : t;
  return /* @__PURE__ */ m(T.Root, { open: y, onOpenChange: f, ...u, children: [
    z && /* @__PURE__ */ i(T.Trigger, { asChild: !0, children: z }),
    /* @__PURE__ */ i(T.Portal, { children: /* @__PURE__ */ i(T.Content, { align: r, side: s, sideOffset: c, collisionPadding: 8, className: v(ve, d), children: n }) })
  ] });
}
De.Item = function({ children: n, onClick: a, variant: e = "default", disabled: r = !1, className: s = "", selected: l, ...c }) {
  return /* @__PURE__ */ m(
    T.Item,
    {
      onClick: a,
      disabled: r,
      className: v(ye, e === "danger" && "text-menu-danger", l && "font-semibold", s),
      ...c,
      children: [
        n,
        l && /* @__PURE__ */ i(be, { size: 16, "aria-hidden": "true", className: "!p-0 ml-auto shrink-0 text-white" })
      ]
    }
  );
};
De.Separator = function({ className: n }) {
  return /* @__PURE__ */ i(T.Separator, { className: v("-mx-1 my-1 h-px bg-zinc-800", n) });
};
De.Label = function({ children: n }) {
  return /* @__PURE__ */ i(T.Label, { className: "px-2.5 pb-1 pt-2 text-caption text-zinc-400", children: n });
};
De.Sub = function({ label: n, icon: a, children: e, contentClassName: r, disabled: s }) {
  return /* @__PURE__ */ m(T.Sub, { children: [
    /* @__PURE__ */ m(T.SubTrigger, { disabled: s, className: ye, children: [
      a,
      /* @__PURE__ */ i("span", { className: "min-w-0 flex-1 truncate", children: n }),
      /* @__PURE__ */ i(Ie, { size: 14, "aria-hidden": "true", className: "!p-0 shrink-0 text-zinc-400" })
    ] }),
    /* @__PURE__ */ i(T.Portal, { children: /* @__PURE__ */ i(T.SubContent, { sideOffset: 6, alignOffset: -4, collisionPadding: 8, className: v(ve, "max-h-[280px] overflow-y-auto", r), children: e }) })
  ] });
};
const En = (t) => {
  var a;
  const n = t.target;
  (a = n == null ? void 0 : n.closest) != null && a.call(n, "[data-radix-popper-content-wrapper]") && t.preventDefault();
};
function Ee({ open: t, onOpenChange: n, title: a, children: e, footer: r, footerStart: s, width: l = 440, trigger: c, hideClose: d, role: u = "dialog", description: p, bodyClassName: g, contentClassName: f }) {
  return /* @__PURE__ */ m(Q.Root, { open: t, onOpenChange: n, children: [
    c && /* @__PURE__ */ i(Q.Trigger, { asChild: !0, children: c }),
    /* @__PURE__ */ m(Q.Portal, { children: [
      /* @__PURE__ */ i(Q.Overlay, { className: "fixed inset-0 z-50 bg-scrim data-[state=open]:animate-in data-[state=open]:fade-in-0" }),
      /* @__PURE__ */ m(
        Q.Content,
        {
          role: u,
          onInteractOutside: En,
          ...p ? {} : { "aria-describedby": void 0 },
          style: { width: `min(${l}px, calc(100% - 2rem))` },
          className: v("fixed left-1/2 top-1/2 z-50 flex max-h-[calc(100%-2rem)] -translate-x-1/2 -translate-y-1/2 flex-col overflow-hidden rounded-card bg-surface text-ink shadow-overlay outline-none data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95", f),
          children: [
            a == null ? /* @__PURE__ */ i(Q.Title, { className: "sr-only", children: "Dialog" }) : /* @__PURE__ */ m("div", { className: "flex h-14 shrink-0 items-center gap-3 border-0 border-b border-solid border-line px-5", children: [
              /* @__PURE__ */ i(Q.Title, { className: "m-0 min-w-0 flex-1 truncate text-body-strong text-ink", children: a }),
              !d && /* @__PURE__ */ i(Q.Close, { "aria-label": "Close", className: "flex size-8 shrink-0 cursor-pointer items-center justify-center rounded-chip border-0 bg-transparent p-0 text-ink hover:bg-surface-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-focus", children: /* @__PURE__ */ i(Z, { className: "!p-0 !text-current", size: 18, "aria-hidden": "true" }) })
            ] }),
            p && /* @__PURE__ */ i(Q.Description, { className: "sr-only", children: p }),
            /* @__PURE__ */ i("div", { className: v("min-h-0 flex-1 overflow-y-auto p-5", g), children: e }),
            (r || s) && /* @__PURE__ */ m("div", { className: "flex shrink-0 items-center gap-3 border-0 border-t border-solid border-line px-5 py-4", children: [
              s,
              /* @__PURE__ */ i("span", { className: "flex-1" }),
              r
            ] })
          ]
        }
      )
    ] })
  ] });
}
const Se = {
  primary: { variant: "primary", className: "" },
  danger: { variant: "primary", className: "!border-danger !bg-danger hover:!border-danger-hover hover:!bg-danger-hover" },
  leave: { variant: "secondary", className: "!text-danger-ink" }
};
function Oa({ open: t, onOpenChange: n, title: a, children: e, confirmLabel: r, cancelLabel: s, tone: l = "primary", busy: c, disabled: d, onConfirm: u, trigger: p, width: g = 400, confirmTestId: f, footerNote: y }) {
  return /* @__PURE__ */ m(
    Ee,
    {
      open: t,
      onOpenChange: n,
      title: a,
      trigger: p,
      width: g,
      role: "alertdialog",
      bodyClassName: "text-callout font-normal text-ink-muted",
      footer: /* @__PURE__ */ m(ae, { children: [
        s && /* @__PURE__ */ i(ze, { variant: "secondary", className: "px-5", onClick: () => n(!1), children: s }),
        /* @__PURE__ */ i(ze, { "data-testid": f, variant: Se[l].variant, className: `px-5 ${Se[l].className}`, disabled: c || d, onClick: u, children: r })
      ] }),
      children: [
        e,
        y
      ]
    }
  );
}
function Ma({ trigger: t, title: n, children: a, confirmLabel: e, cancelLabel: r = "Cancel", tone: s = "primary", confirmDisabled: l, onConfirm: c, onCancel: d, onOpen: u, width: p = 440 }) {
  const [g, f] = Y.useState(!1), [y, N] = Y.useState(!1), z = (x) => {
    x ? u == null || u() : g && (d == null || d()), f(x);
  }, b = async () => {
    N(!0);
    try {
      await (c == null ? void 0 : c()) !== !1 && f(!1);
    } finally {
      N(!1);
    }
  }, S = Y.cloneElement(t, {
    onClick: (x) => {
      var k, A;
      (A = (k = t.props).onClick) == null || A.call(k, x), z(!0);
    }
  });
  return /* @__PURE__ */ m(ae, { children: [
    S,
    /* @__PURE__ */ i(
      Ee,
      {
        open: g,
        onOpenChange: z,
        title: n,
        width: p,
        footer: /* @__PURE__ */ m(ae, { children: [
          r && /* @__PURE__ */ i(ze, { variant: "secondary", className: "px-5", onClick: () => z(!1), children: r }),
          e && /* @__PURE__ */ i(ze, { variant: Se[s].variant, className: `px-5 ${Se[s].className}`, disabled: y || l, onClick: b, children: e })
        ] }),
        children: a
      }
    )
  ] });
}
function Ca({ title: t, close: n = !0, children: a, open: e, onOpenChange: r, trigger: s, noPadding: l = !1, size: c = "default", contentClassName: d }) {
  return /* @__PURE__ */ i(
    Ee,
    {
      open: e,
      onOpenChange: r,
      trigger: s,
      title: t,
      hideClose: !n,
      width: c === "wide" ? 896 : 512,
      bodyClassName: l ? "p-0" : void 0,
      contentClassName: d,
      children: a
    }
  );
}
function _a({ children: t, start: n }) {
  return /* @__PURE__ */ m("div", { className: "-mx-5 -mb-5 mt-5 flex items-center gap-3 border-0 border-t border-solid border-line px-5 py-4", children: [
    n,
    /* @__PURE__ */ i("span", { className: "flex-1" }),
    t
  ] });
}
function Re({
  trigger: t,
  children: n,
  open: a,
  onOpenChange: e,
  align: r = "start",
  side: s = "bottom",
  showCloseIcon: l = !1,
  sideOffset: c = 4,
  modal: d = !0,
  anchorRef: u,
  virtualRef: p,
  preventAutoFocus: g = !1,
  ...f
}) {
  const [y, N] = Fe.useState(!1), z = (k) => {
    N(k), e == null || e(k);
  }, b = a !== void 0 ? a : y, x = t ? l ? /* @__PURE__ */ m("div", { className: "relative inline-block", children: [
    /* @__PURE__ */ i(
      "div",
      {
        className: `transition-opacity duration-200 ${b ? "opacity-0" : "opacity-100"}`,
        children: t
      }
    ),
    /* @__PURE__ */ i(
      "div",
      {
        className: `absolute inset-0 flex items-center justify-center transition-opacity duration-200 ${b ? "opacity-100" : "opacity-0 pointer-events-none"}`,
        children: /* @__PURE__ */ i(Z, { size: 20, className: "text-white bg-zinc-900 rounded-lg p-1" })
      }
    )
  ] }) : t : null;
  return /* @__PURE__ */ m(
    j.Root,
    {
      open: b,
      onOpenChange: z,
      modal: d,
      ...f,
      children: [
        x && /* @__PURE__ */ i(j.Trigger, { asChild: !0, children: x }),
        (u == null ? void 0 : u.current) && /* @__PURE__ */ i(j.Anchor, { asChild: !0, children: /* @__PURE__ */ i("div", { ref: u }) }),
        p && !(u != null && u.current) && /* @__PURE__ */ i(j.Anchor, { asChild: !0, children: /* @__PURE__ */ i(
          "div",
          {
            style: {
              position: "fixed",
              left: p.x,
              top: p.y,
              width: 0,
              height: 0,
              pointerEvents: "none"
            }
          }
        ) }),
        /* @__PURE__ */ i(j.Portal, { children: /* @__PURE__ */ i(
          j.Content,
          {
            align: r,
            side: s,
            sideOffset: c,
            onOpenAutoFocus: g ? (k) => k.preventDefault() : void 0,
            onCloseAutoFocus: g ? (k) => k.preventDefault() : void 0,
            collisionPadding: 8,
            className: ve,
            children: n
          }
        ) })
      ]
    }
  );
}
Re.Item = function({
  children: n,
  onClick: a,
  variant: e = "default",
  disabled: r = !1,
  className: s = "",
  ...l
}) {
  return /* @__PURE__ */ i(
    "div",
    {
      onClick: r ? void 0 : a,
      className: `${ye} hover:bg-zinc-800 focus:bg-zinc-800 ${r ? "pointer-events-none opacity-50" : ""} ${s}`,
      ...l,
      children: n
    }
  );
};
Re.Separator = function({ className: n = "", ...a }) {
  return /* @__PURE__ */ i(
    "div",
    {
      className: `-mx-1 my-1 h-px bg-zinc-800 ${n}`,
      ...a
    }
  );
};
Re.Close = j.Close;
const Rn = ie("flex gap-1 px-4", {
  variants: {
    variant: {
      underline: "border-0 border-b border-solid border-line",
      pill: "w-fit gap-0.5 rounded-control bg-surface-muted p-[3px]"
    }
  },
  defaultVariants: {
    variant: "underline"
  }
}), Vn = ie(
  "box-border cursor-pointer whitespace-nowrap text-callout font-medium transition-colors outline-none focus-visible:ring-2 focus-visible:ring-brand-focus disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        underline: "z-10 -mb-px border-0 border-b-2 border-solid border-transparent bg-transparent p-3 text-ink-muted hover:text-ink data-[state=active]:border-brand data-[state=active]:text-brand-ink",
        pill: "h-8 rounded-[8px] border-0 bg-transparent px-3 text-ink-muted hover:text-ink data-[state=active]:bg-surface data-[state=active]:font-semibold data-[state=active]:text-ink data-[state=active]:shadow-[0_1px_2px_rgba(20,19,28,0.12)]"
      }
    },
    defaultVariants: {
      variant: "underline"
    }
  }
);
function Pa({
  tabs: t,
  activeTab: n,
  onTabChange: a,
  variant: e = "underline",
  className: r,
  listClassName: s,
  contentClassName: l
}) {
  var g;
  const [c, d] = Y.useState(((g = t[0]) == null ? void 0 : g.id) ?? ""), u = n ?? c, p = (f) => {
    a ? a(f) : d(f);
  };
  return /* @__PURE__ */ m(
    we.Root,
    {
      value: u,
      onValueChange: p,
      className: v("flex flex-col", r),
      children: [
        /* @__PURE__ */ i(we.List, { className: v(Rn({ variant: e }), s), children: t.map((f) => /* @__PURE__ */ i(
          we.Trigger,
          {
            value: f.id,
            className: v(Vn({ variant: e })),
            children: f.label
          },
          f.id
        )) }),
        t.map((f) => /* @__PURE__ */ i(
          we.Content,
          {
            value: f.id,
            className: v(l),
            children: f.content
          },
          f.id
        ))
      ]
    }
  );
}
function La({ error: t, className: n }) {
  return t ? /* @__PURE__ */ i("div", { className: v("mt-1.5 w-full max-w-full break-words text-xs leading-4 text-danger-ink text-right", n), children: t }) : null;
}
function pe(t) {
  return pe = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, pe(t);
}
function Bn(t) {
  return (function(n) {
    if (Array.isArray(n)) return je(n);
  })(t) || Nt(t) || Oe(t) || (function() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  })();
}
function Nt(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function ot(t, n) {
  var a = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (!a) {
    if (Array.isArray(t) || (a = Oe(t)) || n) {
      a && (t = a);
      var e = 0, r = function() {
      };
      return { s: r, n: function() {
        return e >= t.length ? { done: !0 } : { done: !1, value: t[e++] };
      }, e: function(d) {
        throw d;
      }, f: r };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var s, l = !0, c = !1;
  return { s: function() {
    a = a.call(t);
  }, n: function() {
    var d = a.next();
    return l = d.done, d;
  }, e: function(d) {
    c = !0, s = d;
  }, f: function() {
    try {
      l || a.return == null || a.return();
    } finally {
      if (c) throw s;
    }
  } };
}
function lt(t, n) {
  var a = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var e = Object.getOwnPropertySymbols(t);
    n && (e = e.filter((function(r) {
      return Object.getOwnPropertyDescriptor(t, r).enumerable;
    }))), a.push.apply(a, e);
  }
  return a;
}
function ct(t) {
  for (var n = 1; n < arguments.length; n++) {
    var a = arguments[n] != null ? arguments[n] : {};
    n % 2 ? lt(Object(a), !0).forEach((function(e) {
      Qn(t, e, a[e]);
    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(a)) : lt(Object(a)).forEach((function(e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(a, e));
    }));
  }
  return t;
}
function Qn(t, n, a) {
  return (n = Dt(n)) in t ? Object.defineProperty(t, n, { value: a, enumerable: !0, configurable: !0, writable: !0 }) : t[n] = a, t;
}
function re(t, n) {
  return St(t) || (function(a, e) {
    var r = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
    if (r != null) {
      var s, l, c, d, u = [], p = !0, g = !1;
      try {
        if (c = (r = r.call(a)).next, e === 0) {
          if (Object(r) !== r) return;
          p = !1;
        } else for (; !(p = (s = c.call(r)).done) && (u.push(s.value), u.length !== e); p = !0) ;
      } catch (f) {
        g = !0, l = f;
      } finally {
        try {
          if (!p && r.return != null && (d = r.return(), Object(d) !== d)) return;
        } finally {
          if (g) throw l;
        }
      }
      return u;
    }
  })(t, n) || Oe(t, n) || zt();
}
function zt() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Oe(t, n) {
  if (t) {
    if (typeof t == "string") return je(t, n);
    var a = Object.prototype.toString.call(t).slice(8, -1);
    return a === "Object" && t.constructor && (a = t.constructor.name), a === "Map" || a === "Set" ? Array.from(t) : a === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? je(t, n) : void 0;
  }
}
function je(t, n) {
  (n == null || n > t.length) && (n = t.length);
  for (var a = 0, e = new Array(n); a < n; a++) e[a] = t[a];
  return e;
}
function St(t) {
  if (Array.isArray(t)) return t;
}
function Un(t, n) {
  for (var a = 0; a < n.length; a++) {
    var e = n[a];
    e.enumerable = e.enumerable || !1, e.configurable = !0, "value" in e && (e.writable = !0), Object.defineProperty(t, Dt(e.key), e);
  }
}
function Dt(t) {
  var n = (function(a, e) {
    if (pe(a) !== "object" || a === null) return a;
    var r = a[Symbol.toPrimitive];
    if (r !== void 0) {
      var s = r.call(a, e);
      if (pe(s) !== "object") return s;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(a);
  })(t, "string");
  return pe(n) === "symbol" ? n : String(n);
}
function P(t, n, a) {
  (function(e, r) {
    if (r.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
  })(t, n), n.set(t, a);
}
function o(t, n) {
  return (function(a, e) {
    return e.get ? e.get.call(a) : e.value;
  })(t, Ot(t, n, "get"));
}
function h(t, n, a) {
  return (function(e, r, s) {
    if (r.set) r.set.call(e, s);
    else {
      if (!r.writable) throw new TypeError("attempted to set read only private field");
      r.value = s;
    }
  })(t, Ot(t, n, "set"), a), a;
}
function Ot(t, n, a) {
  if (!n.has(t)) throw new TypeError("attempted to " + a + " private field on non-instance");
  return n.get(t);
}
function Kn(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function qn(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var dt = { name: "gregorian_en", months: [["January", "Jan"], ["February", "Feb"], ["March", "Mar"], ["April", "Apr"], ["May", "May"], ["June", "Jun"], ["July", "Jul"], ["August", "Aug"], ["September", "Sep"], ["October", "Oct"], ["November", "Nov"], ["December", "Dec"]], weekDays: [["Saturday", "Sat"], ["Sunday", "Sun"], ["Monday", "Mon"], ["Tuesday", "Tue"], ["Wednesday", "Wed"], ["Thursday", "Thu"], ["Friday", "Fri"]], digits: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"], meridiems: [["AM", "am"], ["PM", "pm"]] }, Ne = { name: "gregorian", startYear: 1, yearLength: 365, epoch: 1721424, century: 20, weekStartDayIndex: 1, getMonthLengths: function(t) {
  return [31, t ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
}, isLeap: function(t) {
  return t % 4 == 0 && t % 100 != 0 || t % 400 == 0;
}, getLeaps: function(t) {
  if (t !== 0) {
    for (var n = t > 0 ? 1 : -1, a = []; t > 0 ? n <= t : t <= n; ) this.isLeap(n) && a.push(n), t > 0 ? n++ : n--;
    return a;
  }
}, getDayOfYear: function(t) {
  for (var n = t.year, a = t.month, e = t.day, r = this.getMonthLengths(this.isLeap(n)), s = 0; s < a.index; s++) e += r[s];
  return e;
}, getAllDays: function(t) {
  var n = t.year;
  return this.yearLength * (n - 1) + this.leapsLength(n) + this.getDayOfYear(t);
}, leapsLength: function(t) {
  return ((t - 1) / 4 | 0) + (-(t - 1) / 100 | 0) + ((t - 1) / 400 | 0);
}, guessYear: function(t, n) {
  return ~~(t / 365.24) + (n > 0 ? 1 : -1);
} };
function X(t) {
  return t && t.constructor === Object;
}
function $(t) {
  if (!isNaN(t)) return parseInt(t);
}
function ne(t) {
  return Array.isArray(t);
}
function ce(t, n, a) {
  return t === void 0 || t < n || t > a;
}
var L = /* @__PURE__ */ new WeakMap(), O = /* @__PURE__ */ new WeakMap(), D = /* @__PURE__ */ new WeakMap(), H = /* @__PURE__ */ new WeakMap(), U = /* @__PURE__ */ new WeakMap(), K = /* @__PURE__ */ new WeakMap(), _ = /* @__PURE__ */ new WeakMap(), q = /* @__PURE__ */ new WeakMap(), I = /* @__PURE__ */ new WeakMap(), M = /* @__PURE__ */ new WeakMap(), de = /* @__PURE__ */ new WeakMap(), W = /* @__PURE__ */ new WeakMap(), ut = /* @__PURE__ */ new WeakMap(), ue = /* @__PURE__ */ new WeakMap(), he = /* @__PURE__ */ new WeakMap(), ht = /* @__PURE__ */ new WeakMap(), Pe = /* @__PURE__ */ new WeakMap(), E = /* @__PURE__ */ new WeakMap(), Le = /* @__PURE__ */ new WeakMap(), Gn = (function() {
  function t(e) {
    var r = this;
    (function(d, u) {
      if (!(d instanceof u)) throw new TypeError("Cannot call a class as a function");
    })(this, t), P(this, L, { writable: !0, value: void 0 }), P(this, O, { writable: !0, value: void 0 }), P(this, D, { writable: !0, value: void 0 }), P(this, H, { writable: !0, value: void 0 }), P(this, U, { writable: !0, value: void 0 }), P(this, K, { writable: !0, value: void 0 }), P(this, _, { writable: !0, value: void 0 }), P(this, q, { writable: !0, value: void 0 }), P(this, I, { writable: !0, value: dt }), P(this, M, { writable: !0, value: Ne }), P(this, de, { writable: !0, value: !1 }), P(this, W, { writable: !0, value: {} }), P(this, ut, { writable: !0, value: /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d\.\d\d\dZ$/ }), P(this, ue, { writable: !0, value: [] }), P(this, he, { writable: !0, value: !0 }), P(this, ht, { writable: !0, value: function(d, u) {
      switch (d) {
        case "YYYY":
          return ["year", u];
        case "YY":
          return ["year", "".concat(o(r, M).century).concat(u)];
        case "MMMM":
        case "MMM":
          return ["month", r.months.findIndex((function(g) {
            var f = g.name, y = g.shortName;
            return new RegExp(u, "i").test(f + y);
          })) + 1];
        case "MM":
        case "M":
          return ["month", u];
        case "DD":
        case "D":
          return ["day", u];
        case "HH":
        case "H":
          return ["hour", u];
        case "hh":
        case "h":
          var p = $(u);
          return ["hour", p > 12 ? p - 12 : p];
        case "mm":
        case "m":
          return ["minute", u];
        case "ss":
        case "s":
          return ["second", u];
        case "SSS":
        case "SS":
        case "S":
          return ["millisecond", u];
        default:
          return [];
      }
    } }), P(this, Pe, { writable: !0, value: function() {
      return o(r, L) === 0 && o(r, M).startYear !== 0;
    } }), P(this, E, { writable: !0, value: function() {
      if (o(r, he) && r.isValid) {
        var d = Math.floor, u = function(z, b) {
          return [(k = z, (k < 0 ? -1 : 1) * Math.abs(d(z / b))), (S = z, x = b, (S < 0 && d(S % x) !== -0 ? x : 0) + d(z % b))];
          var S, x, k;
        }, p = function() {
          if (o(r, O) < 0 || o(r, O) > 11) {
            var z = o(r, O) < 0 ? -1 : 1, b = re(u(o(r, O), 12), 2), S = b[0], x = b[1];
            h(r, L, o(r, L) + S), h(r, O, x), o(r, Pe).call(r) && h(r, L, z);
          }
        };
        for (h(r, he, !1), [["millisecond", "second", 1e3], ["second", "minute", 60], ["minute", "hour", 60], ["hour", "day", 24]].forEach((function(z) {
          var b = re(z, 3), S = b[0], x = b[1], k = b[2];
          if ((function(B, G) {
            return B >= G || B < 0;
          })(r[S], k)) {
            var A = re(u(r[S], k), 2), ee = A[0], se = A[1];
            r[x] += ee, r[S] = se;
          }
        })), h(r, he, !0), p(); o(r, D) < -o(r, M).yearLength || o(r, D) > o(r, M).yearLength; ) {
          if (o(r, O) > 0) {
            for (var g = o(r, M).getMonthLengths(r.isLeap), f = 0; f < o(r, O); f++) h(r, D, o(r, D) + g[f]);
            h(r, O, 0);
          }
          var y = r.isLeap ? r.calendar.yearLength + 1 : r.calendar.yearLength;
          h(r, D, o(r, D) + y * (o(r, D) < 0 ? 1 : -1)), h(r, L, o(r, L) + (o(r, D) < 0 ? -1 : 1));
        }
        for (; ; ) {
          var N;
          for (p(); o(r, D) < 1; ) h(r, O, o(r, O) - 1), p(), h(r, D, r.month.length + o(r, D));
          if (o(r, D) <= r.month.length || isNaN(o(r, D))) break;
          h(r, D, o(r, D) - r.month.length), h(r, O, (N = o(r, O), N++, N));
        }
        o(r, H) || h(r, H, 0), o(r, U) || h(r, U, 0), o(r, K) || h(r, K, 0), o(r, _) || h(r, _, 0);
      }
    } }), P(this, Le, { writable: !0, value: function() {
      return (o(r, W).weekDays || o(r, I).weekDays).map((function(d, u) {
        var p = re(d, 2), g = p[0], f = p[1], y = u - r.weekStartDayIndex;
        return y < 0 && (y += 7), { name: g, shortName: f, index: y, number: y + 1, toString: function() {
          return this.number.toString();
        }, valueOf: function() {
          return this.number;
        } };
      }));
    } });
    var s = X(e) ? ct({}, e) : e, l = !0;
    if (s && typeof s != "boolean" || (s = { date: /* @__PURE__ */ new Date() }), X(s) || (s = { date: s }), Object.keys(s).length !== 0) {
      for (var c in X(s.calendar) && h(this, M, s.calendar), X(s.locale) && h(this, I, s.locale), isNaN(s.year) && isNaN(s.month) && isNaN(s.day) && !s.date && (s.date = /* @__PURE__ */ new Date()), s.date && (typeof s.date == "string" && s.format && h(this, q, s.format), this.setDate(s.date), s.calendar && this.convert(s.calendar), l = !1), delete s.calendar, delete s.locale, delete s.date, s) this.set(c, s[c]);
      o(this, Pe).call(this) && h(this, L, -1), l && o(this, E).call(this);
    }
  }
  var n, a;
  return n = t, a = [{ key: "parse", value: function(e) {
    if (!e) return this;
    var r, s, l = o(this, q), c = o(this, I).digits, d = ot(c);
    try {
      for (d.s(); !(r = d.n()).done; ) {
        var u = r.value;
        e = e.replace(new RegExp(u, "g"), c.indexOf(u));
      }
    } catch (oe) {
      d.e(oe);
    } finally {
      d.f();
    }
    if (l) for (var p = l.split(/[^\w\u0600-\u06FF]/), g = e.split(/[^\w\u0600-\u06FF]/), f = 0; f < p.length; f++) this.set.apply(this, Bn(o(this, ht).call(this, p[f], g[f])));
    else {
      var y = e.match(/(-?\d{2,4})?\W?([A-z]{3,9}|\d{1,2})?\W?(\d{1,2})?\W?(\d{1,2})?\W?(\d{1,2})?\W?(\d{1,2})?\W?(\d{1,3})?\W?(am|pm)?/), N = (St(s = y) || Nt(s) || Oe(s) || zt()).slice(1), z = N[1];
      z && (z = /\d+/.test(z) ? $(z) - 1 : this.months.findIndex((function(oe) {
        return new RegExp(z, "i").test(oe.name);
      }))), N[1] = z;
      var b = re(N.map($), 7), S = b[0], x = b[1], k = b[2], A = b[3], ee = b[4], se = b[5], B = b[6];
      h(this, L, S), h(this, O, x), h(this, D, k), h(this, H, A), h(this, U, ee), h(this, K, se), h(this, _, B);
    }
    var G = re(o(this, I).meridiems[1], 2), te = G[0], Me = G[1];
    return o(this, H) < 12 && (e.includes(te) || e.includes(Me)) && h(this, H, o(this, H) + 12), o(this, E).call(this), this;
  } }, { key: "convert", value: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Ne, r = arguments.length > 1 ? arguments[1] : void 0;
    if (X(r) && h(this, I, r), !X(e) || e.name === o(this, M).name) return this;
    var s = this.toJulianDay() - e.epoch, l = new t({ calendar: e, year: e.guessYear(s, o(this, L)), month: 1, day: 1 });
    return l.day += s - l.toDays(), h(this, L, l.year), h(this, O, l.month.index), h(this, D, l.day), h(this, M, e), this;
  } }, { key: "format", value: function(e, r) {
    if (!this.isValid || e && typeof e != "string") return "";
    e || (e = o(this, q) || "YYYY/MM/DD"), ne(r) || (r = []), r = (r = r.concat(o(this, ue))).filter((function(f) {
      return typeof f == "string" || (console.warn("type of all items in the ignore list must be string, found", pe(f)), !1);
    })).map((function(f) {
      return f.replace(/[*/+\-()[\]{}\s$^]/g, (function(y) {
        return "\\" + y;
      }));
    }));
    var s, l = new RegExp("".concat(r.join("|")).concat(r.length > 0 ? "|" : "", "YYYY|YY|MMMM|MMM|MM|M|WW|W|DDDD|DDD|DD|D|dddd|ddd|dd|d|HH|H|hh|h|mm|m|ss|s|SSS|SS|S|A|a|."), "g"), c = "", d = ot(e.match(l) || []);
    try {
      for (d.s(); !(s = d.n()).done; ) {
        var u = s.value, p = this.getValue(u);
        c += r.includes(u) ? u : p === 0 ? p : p || u;
      }
    } catch (f) {
      d.e(f);
    } finally {
      d.f();
    }
    var g = this.digits;
    return c.replace(/[0-9]/g, (function(f) {
      return g[f];
    }));
  } }, { key: "getProperty", value: function(e) {
    return this.getValue(e);
  } }, { key: "getValue", value: function(e) {
    var r = function(s) {
      return s < 10 ? "0" + s : s;
    };
    switch (e) {
      case "YYYY":
        return this.year;
      case "YY":
        return this.year.toString().substring(2, 4);
      case "MMMM":
        return this.month.name;
      case "MMM":
        return this.month.shortName;
      case "MM":
        return r(this.month.number);
      case "M":
        return this.month.number;
      case "WW":
        return r(this.weekOfYear);
      case "W":
        return this.weekOfYear;
      case "DDDD":
      case "DDD":
        return this.dayOfYear;
      case "DD":
        return r(this.day);
      case "D":
        return this.day;
      case "HH":
        return r(this.hour);
      case "H":
        return this.hour;
      case "dddd":
        return this.weekDay.name;
      case "ddd":
        return this.weekDay.shortName;
      case "dd":
        return r(this.weekDay.number);
      case "d":
        return this.weekDay.number;
      case "hh":
        return r(this.hour > 12 ? this.hour - 12 : this.hour || 12);
      case "h":
        return this.hour > 12 ? this.hour - 12 : this.hour || 12;
      case "mm":
        return r(this.minute);
      case "m":
        return this.minute;
      case "ss":
        return r(this.second);
      case "s":
        return this.second;
      case "SSS":
        return o(this, _) < 10 ? "00".concat(o(this, _)) : o(this, _) < 100 ? "0".concat(o(this, _)) : o(this, _);
      case "SS":
        return o(this, _) < 10 ? "00" : o(this, _) < 100 ? ("0" + o(this, _)).substring(2, 0) : o(this, _).toString().substring(0, 2);
      case "S":
        return o(this, _) < 10 || o(this, _) < 100 ? "0" : o(this, _).toString().substring(0, 1);
      case "a":
        return this.hour >= 12 ? o(this, I).meridiems[1][1] : o(this, I).meridiems[0][1];
      case "A":
        return this.hour >= 12 ? o(this, I).meridiems[1][0] : o(this, I).meridiems[0][0];
      default:
        return "";
    }
  } }, { key: "setYear", value: function(e) {
    return this.year = e, this;
  } }, { key: "setMonths", value: function(e) {
    return this.months = e, this;
  } }, { key: "setMonth", value: function(e) {
    return this.month = e, this;
  } }, { key: "setWeekDays", value: function(e) {
    return this.weekDays = e, this;
  } }, { key: "setDigits", value: function(e) {
    return this.digits = e, this;
  } }, { key: "setDay", value: function(e) {
    return this.day = e, this;
  } }, { key: "setHour", value: function(e) {
    return this.hour = e, this;
  } }, { key: "setMinute", value: function(e) {
    return this.minute = e, this;
  } }, { key: "setSecond", value: function(e) {
    return this.second = e, this;
  } }, { key: "setMillisecond", value: function(e) {
    return this.millisecond = e, this;
  } }, { key: "setFormat", value: function(e) {
    return h(this, q, e), this;
  } }, { key: "setLocale", value: function(e) {
    return this.locale = e, this;
  } }, { key: "setCalendar", value: function(e) {
    return this.calendar = e, this;
  } }, { key: "setDate", value: function(e) {
    if (typeof e == "string") {
      if (!o(this, ut).test(e)) return this.parse(e);
      e = new Date(e);
    }
    return typeof e == "number" && (e = new Date(e)), e instanceof Date && (h(this, M, Ne), h(this, L, e.getFullYear()), h(this, O, e.getMonth()), h(this, D, e.getDate()), h(this, H, e.getHours()), h(this, U, e.getMinutes()), h(this, K, e.getSeconds()), h(this, _, e.getMilliseconds()), h(this, de, !1)), e instanceof t && (h(this, L, e.year), h(this, O, e.month.index), h(this, D, e.day), h(this, H, e.hour), h(this, U, e.minute), h(this, K, e.second), h(this, _, e.millisecond), h(this, I, e.locale), h(this, q, e._format), h(this, M, e.calendar), h(this, de, e.isUTC), h(this, ue, e.ignoreList), h(this, W, e.custom)), this;
  } }, { key: "setIgnoreList", value: function(e) {
    return this.ignoreList = e, this;
  } }, { key: "set", value: function(e, r) {
    if (e == null) return this;
    if (X(e)) {
      var s = ct({}, e);
      for (var l in s.date && (this.setDate(s.date), delete s.date), s.calendar && (this.convert(s.calendar), delete s.calendar), s.locale && (this.setLocale(s.locale), delete s.locale), h(this, he, !1), s) this.set(l, s[l]);
      return h(this, he, !0), o(this, E).call(this), this;
    }
    e === "format" && (e = "_format");
    try {
      this[e] = r;
    } catch {
    }
    return this;
  } }, { key: "add", value: function(e, r) {
    if (!(e = $(e)) || !r) return this;
    switch (r) {
      case "years":
      case "y":
        r = "year";
        break;
      case "months":
      case "M":
        r = "month";
        break;
      case "days":
      case "d":
        r = "day";
        break;
      case "hours":
      case "h":
        r = "hour";
        break;
      case "minutes":
      case "m":
        r = "minute";
        break;
      case "seconds":
      case "s":
        r = "second";
        break;
      case "milliseconds":
      case "ms":
        r = "millisecond";
    }
    return this[r] += e, this;
  } }, { key: "subtract", value: function(e, r) {
    return this.add(-e, r);
  } }, { key: "toFirstOfYear", value: function() {
    return this.month = 1, this.day = 1, this;
  } }, { key: "toLastOfYear", value: function() {
    return this.day >= 29 && (this.day = 29), this.month = 12, this.toLastOfMonth(), this;
  } }, { key: "toFirstOfMonth", value: function() {
    return h(this, D, 1), this;
  } }, { key: "toLastOfMonth", value: function() {
    return h(this, D, 0), h(this, O, o(this, O) + 1), o(this, E).call(this), this;
  } }, { key: "toFirstOfWeek", value: function() {
    return this.day -= this.weekDay.index, this;
  } }, { key: "toLastOfWeek", value: function() {
    return this.day += 6 - this.weekDay.index, this;
  } }, { key: "toFirstWeekOfYear", value: function() {
    return this.toFirstOfYear(), this.weekDay.index === 0 ? this : this.toLastOfWeek().setDay(this.day + 1);
  } }, { key: "toLastWeekOfYear", value: function() {
    return this.toLastOfYear().toFirstOfWeek();
  } }, { key: "toString", value: function() {
    return this.format();
  } }, { key: "toDate", value: function() {
    var e = new t(this);
    return o(this, M).name !== "gregorian" && e.convert(Ne), new Date(e.year, e.month.index, e.day, e.hour, e.minute, e.second, e.millisecond);
  } }, { key: "toUTC", value: function() {
    return o(this, de) || (this.minute += this.toDate().getTimezoneOffset(), h(this, de, !0)), this;
  } }, { key: "toUnix", value: function() {
    return this.unix;
  } }, { key: "toJulianDay", value: function() {
    return this.toDays() + o(this, M).epoch;
  } }, { key: "toObject", value: function() {
    return { year: o(this, L), month: this.month, day: o(this, D), weekDay: this.weekDay, hour: o(this, H), minute: o(this, U), second: o(this, K), millisecond: o(this, _), weekOfYear: this.weekOfYear, dayOfYear: this.dayOfYear, daysLeft: this.daysLeft, calendar: o(this, M), locale: o(this, I), format: o(this, q) || "YYYY/MM/DD", ignoreList: o(this, ue) };
  } }, { key: "toJSON", value: function() {
    return this.valueOf();
  } }, { key: "valueOf", value: function() {
    return this.toDate().valueOf();
  } }, { key: "toDays", value: function() {
    if (this.isValid) return o(this, M).getAllDays(this);
  } }, { key: "dayOfBeginning", get: function() {
    return this.toDays();
  } }, { key: "dayOfYear", get: function() {
    if (this.isValid) return o(this, M).getDayOfYear(this);
  } }, { key: "weekOfYear", get: function() {
    if (this.isValid) return 1 + ~~(this.dayOfYear / 7);
  } }, { key: "daysLeft", get: function() {
    if (this.isValid) {
      var e = o(this, M).yearLength;
      return (this.isLeap ? e + 1 : e) - this.dayOfYear;
    }
  } }, { key: "year", get: function() {
    return o(this, L);
  }, set: function(e) {
    h(this, L, $(e)), o(this, E).call(this);
  } }, { key: "month", get: function() {
    return this.months[o(this, O)] || {};
  }, set: function(e) {
    var r;
    e = (r = $(e.valueOf()) - 1) !== null && r !== void 0 ? r : void 0, h(this, O, e), ce(e, 0, 11) && o(this, E).call(this);
  } }, { key: "monthIndex", get: function() {
    return o(this, O);
  } }, { key: "day", get: function() {
    return o(this, D);
  }, set: function(e) {
    e = $(e), h(this, D, e), ce(e, 1, 28) && o(this, E).call(this);
  } }, { key: "weekDay", get: function() {
    if (!this.isValid) return {};
    var e = (this.toJulianDay() + 3) % 7;
    return o(this, Le).call(this)[e];
  } }, { key: "hour", get: function() {
    return o(this, H);
  }, set: function(e) {
    e = $(e), h(this, H, e), ce(e, 0, 23) && o(this, E).call(this);
  } }, { key: "minute", get: function() {
    return o(this, U);
  }, set: function(e) {
    e = $(e), h(this, U, e), ce(e, 0, 59) && o(this, E).call(this);
  } }, { key: "second", get: function() {
    return o(this, K);
  }, set: function(e) {
    e = $(e), h(this, K, e), ce(e, 0, 59) && o(this, E).call(this);
  } }, { key: "millisecond", get: function() {
    return o(this, _);
  }, set: function(e) {
    e = $(e), h(this, _, e), ce(e, 0, 999) && o(this, E).call(this);
  } }, { key: "months", get: function() {
    var e = o(this, M).getMonthLengths(this.isLeap), r = (o(this, W).months || o(this, I).months).map((function(s, l) {
      var c = re(s, 2);
      return { name: c[0], shortName: c[1], length: e[l], index: l, number: l + 1, toString: function() {
        return this.number.toString();
      }, valueOf: function() {
        return this.number;
      } };
    }));
    return r;
  }, set: function(e) {
    if (!e) return delete o(this, W).months;
    ne(e) && e.length === 12 && e.every((function(r) {
      return ne(r) && r.length === 2 && r.every((function(s) {
        return typeof s == "string";
      }));
    })) && (o(this, W).months = e);
  } }, { key: "weekDays", get: function() {
    return o(this, Le).call(this).sort((function(e, r) {
      return e.index - r.index;
    }));
  }, set: function(e) {
    if (!e) return delete o(this, W).weekDays;
    ne(e) && e.length === 7 && e.every((function(r) {
      return ne(r) && r.length === 2 && r.every((function(s) {
        return typeof s == "string";
      }));
    })) && (o(this, W).weekDays = e);
  } }, { key: "leaps", get: function() {
    return o(this, M).getLeaps(o(this, L));
  } }, { key: "calendar", get: function() {
    return o(this, M);
  }, set: function(e) {
    this.convert(e);
  } }, { key: "locale", get: function() {
    return o(this, I);
  }, set: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : dt;
    X(e) && h(this, I, e);
  } }, { key: "custom", get: function() {
    return o(this, W);
  } }, { key: "meridiems", get: function() {
    return o(this, I).meridiems;
  } }, { key: "digits", get: function() {
    return o(this, W).digits || o(this, I).digits;
  }, set: function(e) {
    if (!e) return delete o(this, W).digits;
    ne(e) && e.length === 10 && (o(this, W).digits = e);
  } }, { key: "_format", get: function() {
    return o(this, q);
  }, set: function(e) {
    typeof e == "string" && h(this, q, e);
  } }, { key: "isLeap", get: function() {
    return o(this, M).isLeap(o(this, L));
  } }, { key: "isValid", get: function() {
    return !isNaN(o(this, L)) && !isNaN(o(this, O)) && !isNaN(o(this, D));
  } }, { key: "isUTC", get: function() {
    return o(this, de);
  } }, { key: "unix", get: function() {
    return (this.valueOf() - this.millisecond) / 1e3;
  } }, { key: "ignoreList", get: function() {
    return o(this, ue);
  }, set: function(e) {
    ne(e) && h(this, ue, e);
  } }, { key: "weekStartDayIndex", get: function() {
    return o(this, M).weekStartDayIndex;
  }, set: function(e) {
    (e = $(e)) !== void 0 && (o(this, M).weekStartDayIndex = Math.abs(e) % 7);
  } }, { key: "date", set: function(e) {
    this.setDate(e);
  } }], a && Un(n.prototype, a), Object.defineProperty(n, "prototype", { writable: !1 }), t;
})(), C = Kn(qn(Gn));
const ft = [
  { label: "Today", value: "today" },
  { label: "Yesterday", value: "yesterday" },
  { label: "This week", value: "this-week" },
  { label: "Last week", value: "last-week" },
  { label: "This month", value: "this-month" },
  { label: "Last month", value: "last-month" },
  { label: "This year", value: "this-year" },
  { label: "Last year", value: "last-year" },
  { label: "All time", value: "all-time" }
], R = (t) => t.setHour(0).setMinute(0).setSecond(0).setMillisecond(0), V = (t) => t.setHour(23).setMinute(59).setSecond(59).setMillisecond(999);
function Te(t) {
  switch (t) {
    case "today":
      return [R(new C()), V(new C())];
    case "yesterday":
      return [
        R(new C().subtract(1, "day")),
        V(new C().subtract(1, "day"))
      ];
    case "this-week":
      return [
        R(new C().toFirstOfWeek()),
        V(new C().toLastOfWeek())
      ];
    case "last-week":
      return [
        R(new C().subtract(7, "days").toFirstOfWeek()),
        V(new C().subtract(7, "days").toLastOfWeek())
      ];
    case "this-month":
      return [
        R(new C().toFirstOfMonth()),
        V(new C().toLastOfMonth())
      ];
    case "last-month":
      return [
        R(new C().subtract(1, "month").toFirstOfMonth()),
        V(new C().subtract(1, "month").toLastOfMonth())
      ];
    case "this-year":
      return [
        R(new C().toFirstOfYear()),
        V(new C().toLastOfYear())
      ];
    case "last-year":
      return [
        R(new C().subtract(1, "year").toFirstOfYear()),
        V(new C().subtract(1, "year").toLastOfYear())
      ];
    case "all-time":
      return [
        R(new C().subtract(100, "year")),
        V(new C().add(100, "year"))
      ];
    default:
      return [
        R(new C().toFirstOfMonth()),
        V(new C().toLastOfMonth())
      ];
  }
}
function Ta({
  onDateConfirm: t,
  trigger: n,
  className: a,
  defaultOption: e = "all-time",
  defaultDates: r
}) {
  const s = Ae(null), [l, c] = me(8), u = e ? Te(e) : ((x) => !x || x.length === 0 ? null : x.map((k) => k instanceof C ? k : new C(k)))(r) ?? Te("all-time"), [p, g] = me(e), [f, y] = me(u), N = Ae(!0), z = (x) => {
    var k;
    return (k = ft.find((A) => A.value === x)) == null ? void 0 : k.label;
  };
  xe(() => {
    if (N.current) {
      N.current = !1;
      return;
    }
    const x = z(p);
    t(f, x);
  }, [f]);
  const b = (x) => {
    g(x);
    const k = Te(x);
    y(k);
  }, S = (x) => {
    if (!x) return;
    const k = Array.isArray(x) ? x : [x];
    g(""), k.length === 2 ? y([R(k[0]), V(k[1])]) : k.length === 1 && y([R(k[0])]);
  };
  return xe(() => {
    const x = () => {
      if (!s.current) return;
      const k = s.current.getBoundingClientRect(), A = window.innerHeight - k.bottom;
      c(A < 420 ? A - 430 : 8);
    };
    return x(), window.addEventListener("resize", x), () => window.removeEventListener("resize", x);
  }, []), /* @__PURE__ */ m(j.Root, { children: [
    /* @__PURE__ */ i(j.Trigger, { ref: s, asChild: !0, children: n }),
    /* @__PURE__ */ i(j.Portal, { children: /* @__PURE__ */ i(
      j.Content,
      {
        sideOffset: l,
        side: "bottom",
        align: "start",
        className: "z-50",
        children: /* @__PURE__ */ m(
          "div",
          {
            className: v(
              "bg-surface border border-zinc-300 rounded-xl shadow-[0px_6px_16px_-2px_rgba(0,0,0,0.11),0px_2px_8px_0px_rgba(0,0,0,0.1)] flex gap-4 p-4 overflow-hidden",
              a
            ),
            children: [
              /* @__PURE__ */ i("div", { className: "flex flex-col w-[160px] shrink-0", children: ft.map((x) => {
                const k = x.value === p;
                return /* @__PURE__ */ i(
                  "button",
                  {
                    onClick: () => b(x.value),
                    className: v(
                      "text-left px-3 py-2 rounded-[10px] text-[13px] font-medium leading-4 cursor-pointer transition-colors whitespace-nowrap",
                      k ? "bg-brand-tint text-brand-ink" : "text-zinc-700 hover:bg-zinc-50"
                    ),
                    children: x.label
                  },
                  x.value
                );
              }) }),
              /* @__PURE__ */ i("div", { className: "border-l border-zinc-200 pl-4", children: /* @__PURE__ */ i(
                vn,
                {
                  className: "phq-datepicker",
                  value: p === "all-time" ? [] : f,
                  currentDate: p === "all-time" ? new C() : f[0],
                  onChange: S,
                  numberOfMonths: 1,
                  weekStartDayIndex: 1,
                  range: !0,
                  showOtherDays: !0
                },
                p || "custom"
              ) })
            ]
          }
        )
      }
    ) })
  ] });
}
function Aa({ content: t, children: n, side: a = "top", align: e = "center", delay: r = 200, open: s, onOpenChange: l, className: c }) {
  return t == null || t === "" ? n : /* @__PURE__ */ i(ge.Provider, { delayDuration: r, children: /* @__PURE__ */ m(ge.Root, { open: s, onOpenChange: l, children: [
    /* @__PURE__ */ i(ge.Trigger, { asChild: !0, children: n }),
    /* @__PURE__ */ i(ge.Portal, { children: /* @__PURE__ */ i(
      ge.Content,
      {
        side: a,
        align: e,
        sideOffset: 6,
        collisionPadding: 8,
        className: v(
          "z-[80] max-w-[320px] whitespace-pre-line rounded-chip bg-zinc-950 px-2.5 py-1.5 text-footnote font-normal leading-[18px] text-white shadow-menu",
          "data-[state=delayed-open]:animate-in data-[state=delayed-open]:fade-in-0",
          c
        ),
        children: t
      }
    ) })
  ] }) });
}
function Ia({ value: t, onChange: n, options: a, placeholder: e = "Select", label: r, id: s, error: l, disabled: c, className: d, onScrollEnd: u, renderValue: p, ...g }) {
  const f = Y.useId(), y = s ?? f, N = a.find((b) => b.value === t), z = (b) => {
    const S = b.currentTarget;
    u && S.scrollTop + S.clientHeight >= S.scrollHeight - 8 && u();
  };
  return /* @__PURE__ */ m("div", { className: v("flex min-w-0 flex-col gap-1.5", d), children: [
    r && /* @__PURE__ */ i("label", { htmlFor: y, className: "text-footnote font-medium text-ink-secondary", children: r }),
    /* @__PURE__ */ m(T.Root, { modal: !1, children: [
      /* @__PURE__ */ i(T.Trigger, { asChild: !0, disabled: c, children: /* @__PURE__ */ m(
        "button",
        {
          id: y,
          type: "button",
          "aria-label": g["aria-label"],
          "aria-invalid": !!l || void 0,
          className: v(
            "box-border flex h-control-md w-full min-w-0 cursor-pointer items-center gap-2 rounded-control border border-solid border-fill-subtle bg-surface px-3 text-left text-callout text-ink outline-none",
            "hover:bg-surface-muted focus-visible:ring-2 focus-visible:ring-brand-focus data-[state=open]:ring-2 data-[state=open]:ring-brand-focus",
            "disabled:cursor-not-allowed disabled:bg-surface-muted disabled:text-ink-disabled",
            l && "border-danger-ink"
          ),
          children: [
            p ? p(N) : /* @__PURE__ */ m(ae, { children: [
              N == null ? void 0 : N.icon,
              /* @__PURE__ */ i("span", { className: v("min-w-0 flex-1 truncate", !N && "text-ink-muted"), children: (N == null ? void 0 : N.label) ?? e })
            ] }),
            /* @__PURE__ */ i(xt, { size: 16, "aria-hidden": "true", className: "!p-0 ml-auto shrink-0 text-ink-muted" })
          ]
        }
      ) }),
      /* @__PURE__ */ i(T.Portal, { children: /* @__PURE__ */ i(
        T.Content,
        {
          align: "start",
          sideOffset: 6,
          collisionPadding: 8,
          onScroll: z,
          className: v(ve, "max-h-[min(320px,var(--radix-dropdown-menu-content-available-height))] min-w-[var(--radix-dropdown-menu-trigger-width)] overflow-y-auto"),
          children: /* @__PURE__ */ i(T.RadioGroup, { value: t ?? "", onValueChange: (b) => n(b), children: a.map((b) => /* @__PURE__ */ m(T.RadioItem, { value: b.value, disabled: b.disabled, className: v(ye, "data-[state=checked]:font-semibold"), children: [
            b.icon,
            /* @__PURE__ */ m("span", { className: "flex min-w-0 flex-1 flex-col", children: [
              /* @__PURE__ */ i("span", { className: "truncate", children: b.label }),
              b.description && /* @__PURE__ */ i("span", { className: "truncate text-footnote font-normal text-zinc-400", children: b.description })
            ] }),
            /* @__PURE__ */ i(T.ItemIndicator, { children: /* @__PURE__ */ i(be, { size: 16, "aria-hidden": "true", className: "!p-0 shrink-0" }) })
          ] }, b.value)) })
        }
      ) })
    ] }),
    l && /* @__PURE__ */ i("p", { role: "alert", className: "m-0 text-footnote text-danger-ink", children: l })
  ] });
}
function Ya({ items: t, onSelect: n, value: a, label: e, placeholder: r = "Search", onInputChange: s, onScrollEnd: l, clearOnSelect: c, error: d, disabled: u, id: p, className: g, emptyText: f = "No results" }) {
  const y = Y.useId(), N = p ?? y, z = `${N}-list`, [b, S] = Y.useState(!1), [x, k] = Y.useState(""), [A, ee] = Y.useState(0), se = Y.useRef(null), B = t.find((w) => w.value === a), G = x.trim().toLowerCase(), te = s || !G ? t : t.filter((w) => {
    var F;
    return (w.label ?? w.value).toLowerCase().includes(G) || ((F = w.description) == null ? void 0 : F.toLowerCase().includes(G));
  });
  Y.useEffect(() => ee(0), [x, b]);
  const Me = (w) => {
    k(w), S(!0), s == null || s(w);
  }, oe = (w) => {
    n(w), k(""), s == null || s(""), c || S(!1);
  }, _t = (w) => {
    var F, ke;
    if (w.key === "ArrowDown" || w.key === "ArrowUp") {
      w.preventDefault(), S(!0);
      const Ve = Math.max(0, Math.min(te.length - 1, A + (w.key === "ArrowDown" ? 1 : -1)));
      ee(Ve), (ke = (F = se.current) == null ? void 0 : F.querySelector(`[data-index="${Ve}"]`)) == null || ke.scrollIntoView({ block: "nearest" });
    } else w.key === "Enter" && b && te[A] ? (w.preventDefault(), oe(te[A])) : w.key === "Escape" && b && (w.stopPropagation(), S(!1));
  }, Pt = (w) => {
    const F = w.currentTarget;
    l && F.scrollTop + F.clientHeight >= F.scrollHeight - 24 && l();
  }, Lt = b || c ? x : x || (B == null ? void 0 : B.label) || "";
  return /* @__PURE__ */ m("div", { className: v("flex min-w-0 flex-col gap-1.5", g), children: [
    e && /* @__PURE__ */ i("label", { htmlFor: N, className: "text-footnote font-medium text-ink-secondary", children: e }),
    /* @__PURE__ */ m(j.Root, { open: b && !u, onOpenChange: S, children: [
      /* @__PURE__ */ i(j.Anchor, { asChild: !0, children: /* @__PURE__ */ m("span", { className: "relative flex items-center", children: [
        /* @__PURE__ */ i($e, { size: 16, "aria-hidden": "true", className: "!p-0 pointer-events-none absolute left-3 text-ink-muted" }),
        /* @__PURE__ */ i(
          "input",
          {
            id: N,
            role: "combobox",
            "aria-expanded": b,
            "aria-controls": z,
            "aria-autocomplete": "list",
            "aria-invalid": !!d || void 0,
            autoComplete: "off",
            disabled: u,
            value: Lt,
            placeholder: B && !c ? B.label : r,
            onChange: (w) => Me(w.target.value),
            onFocus: () => S(!0),
            onClick: () => S(!0),
            onKeyDown: _t,
            className: v(
              "box-border h-control-md w-full rounded-control border border-solid border-fill-subtle bg-surface pl-9 pr-3 text-callout text-ink outline-none placeholder:text-ink-muted",
              "focus:border-transparent focus:ring-2 focus:ring-brand-focus disabled:cursor-not-allowed disabled:bg-surface-muted disabled:text-ink-disabled",
              d && "border-danger-ink"
            )
          }
        )
      ] }) }),
      /* @__PURE__ */ i(j.Portal, { children: /* @__PURE__ */ i(
        j.Content,
        {
          align: "start",
          sideOffset: 6,
          collisionPadding: 8,
          onOpenAutoFocus: (w) => w.preventDefault(),
          onInteractOutside: (w) => {
            w.target.id === N && w.preventDefault();
          },
          className: v(ve, "w-[var(--radix-popover-trigger-width)]"),
          children: /* @__PURE__ */ m("div", { ref: se, id: z, role: "listbox", onScroll: Pt, className: "max-h-[280px] overflow-y-auto", children: [
            te.length === 0 && /* @__PURE__ */ i("div", { className: "px-2.5 py-2 text-footnote text-zinc-400", children: f }),
            te.map((w, F) => /* @__PURE__ */ m(
              "div",
              {
                role: "option",
                "data-index": F,
                "aria-selected": w.value === a,
                "data-highlighted": F === A ? "" : void 0,
                onMouseDown: (ke) => ke.preventDefault(),
                onMouseEnter: () => ee(F),
                onClick: () => oe(w),
                className: v(ye, w.value === a && "font-semibold"),
                children: [
                  w.prefixElement,
                  /* @__PURE__ */ m("span", { className: "flex min-w-0 flex-1 flex-col", children: [
                    /* @__PURE__ */ i("span", { className: "truncate", children: w.label ?? w.value }),
                    w.description && /* @__PURE__ */ i("span", { className: "truncate text-footnote font-normal text-zinc-400", children: w.description })
                  ] }),
                  w.value === a && /* @__PURE__ */ i(be, { size: 16, "aria-hidden": "true", className: "!p-0 shrink-0" })
                ]
              },
              w.key
            ))
          ] })
        }
      ) })
    ] }),
    d && /* @__PURE__ */ i("p", { role: "alert", className: "m-0 text-footnote text-danger-ink", children: d })
  ] });
}
const Mt = ({ checked: t }) => /* @__PURE__ */ i("span", { "aria-hidden": "true", className: v("box-border flex size-[22px] flex-none items-center justify-center rounded-full", t ? "bg-brand" : "border-2 border-solid border-fill-subtle"), children: t && /* @__PURE__ */ i("span", { className: "size-2 rounded-full bg-white" }) }), Ct = "box-border flex min-h-12 w-full cursor-pointer items-center gap-3 px-4 py-2 text-left outline-none hover:bg-surface-muted focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-focus disabled:cursor-not-allowed disabled:opacity-50";
function ja({ label: t, value: n, onChange: a, options: e, className: r }) {
  return /* @__PURE__ */ i("div", { role: "radiogroup", "aria-label": t, className: v("flex flex-col overflow-hidden rounded-xl border border-solid border-line bg-surface", r), children: e.map((s, l) => {
    const c = s.value === n;
    return /* @__PURE__ */ m(Y.Fragment, { children: [
      l > 0 && /* @__PURE__ */ i("div", { "aria-hidden": "true", className: "mx-4 h-px bg-line" }),
      /* @__PURE__ */ m("button", { type: "button", role: "radio", "aria-checked": c, disabled: s.disabled, onClick: () => a(s.value), className: Ct, children: [
        /* @__PURE__ */ i(Mt, { checked: c }),
        /* @__PURE__ */ m("span", { className: "flex min-w-0 flex-1 flex-col gap-0.5", children: [
          /* @__PURE__ */ i("span", { className: v("text-callout text-ink", c && "font-semibold"), children: s.label }),
          s.description && /* @__PURE__ */ i("span", { className: "text-footnote text-ink-muted", children: s.description })
        ] })
      ] })
    ] }, s.value);
  }) });
}
const Fa = ({ checked: t, onSelect: n, label: a, description: e, className: r }) => /* @__PURE__ */ m("button", { type: "button", role: "radio", "aria-checked": t, onClick: n, className: v(Ct, "min-h-0 px-0 py-0 hover:bg-transparent", r), children: [
  /* @__PURE__ */ i(Mt, { checked: t }),
  /* @__PURE__ */ m("span", { className: "flex min-w-0 flex-1 flex-col gap-0.5", children: [
    /* @__PURE__ */ i("span", { className: "text-callout font-semibold text-ink", children: a }),
    e && /* @__PURE__ */ i("span", { className: "text-footnote text-ink-muted", children: e })
  ] })
] });
function $a({ label: t, propertyName: n, onSort: a, className: e }) {
  const [r, s] = Y.useState("ASC"), l = v("flex items-center gap-1 text-left text-footnote font-semibold text-ink-secondary", e);
  if (!a) return /* @__PURE__ */ i("div", { className: l, children: t });
  const c = () => {
    const u = r === "ASC" ? "DESC" : "ASC";
    s(u), a(u, n);
  }, d = r === "ASC" ? fn : mn;
  return /* @__PURE__ */ m(
    "button",
    {
      type: "button",
      onClick: c,
      "aria-label": typeof t == "string" ? `${t}, sorted ${r === "ASC" ? "ascending" : "descending"}` : void 0,
      className: v(l, "box-border cursor-pointer rounded-chip outline-none hover:text-ink focus-visible:ring-2 focus-visible:ring-brand-focus"),
      children: [
        t,
        /* @__PURE__ */ i(d, { size: 14, "aria-hidden": "true", className: "!p-0 shrink-0 !text-current" })
      ]
    }
  );
}
function Ha({ checked: t, onCheckedChange: n, disabled: a, loading: e, label: r, description: s, error: l, switchFirst: c, id: d, className: u, labelClassName: p, ...g }) {
  const f = Y.useId(), y = d ?? f, N = e ? /* @__PURE__ */ i("span", { className: "flex h-[26px] w-11 flex-none items-center justify-center", role: "status", "aria-label": "Saving", children: /* @__PURE__ */ i(pn, { size: 18, "aria-hidden": "true", className: "!p-0 animate-spin text-ink-muted" }) }) : /* @__PURE__ */ i(
    et.Root,
    {
      id: y,
      checked: t,
      disabled: a,
      onCheckedChange: n,
      "aria-label": g["aria-label"] ?? (typeof r == "string" ? r : void 0),
      ...g["phq-id"] ? { "phq-id": g["phq-id"] } : {},
      className: "relative box-border h-[26px] w-11 flex-none cursor-pointer rounded-full border-0 bg-fill-subtle p-0 outline-none transition-colors focus-visible:ring-2 focus-visible:ring-brand-focus focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-brand",
      children: /* @__PURE__ */ i(et.Thumb, { className: "block size-[22px] translate-x-0.5 rounded-full bg-toggle-knob shadow-[0_1px_2px_rgba(20,19,28,0.2)] transition-transform data-[state=checked]:translate-x-5" })
    }
  );
  return !r && !s ? /* @__PURE__ */ i("span", { className: v("inline-flex", u), children: N }) : /* @__PURE__ */ m("div", { className: v("flex w-full items-center gap-3", c && "flex-row-reverse justify-end", u), children: [
    /* @__PURE__ */ m("label", { htmlFor: y, className: v("flex min-w-0 flex-1 cursor-pointer flex-col gap-0.5", c && "flex-none", p), children: [
      r && /* @__PURE__ */ i("span", { className: v("text-callout text-ink", l && "text-danger-ink"), children: r }),
      s && /* @__PURE__ */ i("span", { className: v("text-footnote text-ink-muted", l && "text-danger-ink"), children: s })
    ] }),
    N
  ] });
}
const mt = {
  info: vt,
  check: be,
  success: bn,
  warning: kt,
  error: He,
  cloud_off: bt,
  mic_off: gt,
  "message-square-text": pt
}, Xn = { info: "info", success: "success", warning: "warning", error: "error" }, Jn = {
  info: "bg-brand/25 text-indigo-300",
  success: "bg-emerald-500/20 text-emerald-300",
  warning: "bg-amber-500/20 text-amber-300",
  error: "bg-red-500/20 text-red-300"
};
function Wa({ title: t, description: n, type: a, open: e, onOpenChange: r, position: s = "default", icon: l, onClick: c }) {
  const d = mt[l ?? ""] ?? mt[Xn[a]];
  return /* @__PURE__ */ m(le.Provider, { swipeDirection: "right", children: [
    /* @__PURE__ */ m(
      le.Root,
      {
        open: e,
        onOpenChange: r,
        className: "box-border flex items-center gap-3 rounded-xl bg-zinc-950 py-3 pl-3.5 pr-2.5 text-white shadow-overlay ring-1 ring-inset ring-white/10 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[swipe=end]:animate-out",
        children: [
          /* @__PURE__ */ i("span", { "aria-hidden": "true", className: v("flex size-8 shrink-0 items-center justify-center rounded-full", Jn[a]), children: /* @__PURE__ */ i(d, { size: 16, className: "!p-0 !text-current" }) }),
          /* @__PURE__ */ m("div", { onClick: c, className: v("min-w-0 flex-1", c && "cursor-pointer"), children: [
            t && /* @__PURE__ */ i(le.Title, { className: "truncate text-callout font-semibold text-white", children: t }),
            n && /* @__PURE__ */ i(le.Description, { className: "mt-0.5 line-clamp-2 text-footnote text-zinc-400", children: n })
          ] }),
          /* @__PURE__ */ i(
            le.Close,
            {
              "aria-label": "Close notification",
              className: "box-border flex size-7 shrink-0 cursor-pointer items-center justify-center rounded-chip border-0 bg-transparent p-0 text-zinc-400 hover:bg-zinc-800 hover:text-white focus-visible:ring-2 focus-visible:ring-brand-focus",
              children: /* @__PURE__ */ i(Z, { size: 16, "aria-hidden": "true", className: "!p-0 !text-current" })
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ i(
      le.Viewport,
      {
        className: v(
          "fixed z-[2147483647] m-0 flex max-w-[100vw] list-none flex-col gap-2.5 p-6 outline-none",
          s === "center" ? "bottom-0 left-1/2 w-[500px] -translate-x-1/2" : "right-0 top-0 w-[420px]"
        )
      }
    )
  ] });
}
function Zn({ label: t, className: n, size: a = 20 }) {
  return /* @__PURE__ */ m("span", { role: "status", className: "inline-flex items-center gap-2", children: [
    /* @__PURE__ */ i(
      "span",
      {
        "aria-hidden": "true",
        style: { width: a, height: a },
        className: v("box-border inline-block shrink-0 animate-spin rounded-full border-2 border-solid border-fill-subtle border-t-brand motion-reduce:animate-[spin_1.5s_linear_infinite]", n)
      }
    ),
    t ? /* @__PURE__ */ i("span", { className: "text-footnote text-ink-muted", children: t }) : /* @__PURE__ */ i("span", { className: "sr-only", children: "Loading" })
  ] });
}
function Ea({ className: t, label: n }) {
  return /* @__PURE__ */ i("div", { className: v("mx-auto flex h-screen items-center justify-center", t), children: /* @__PURE__ */ i(Zn, { size: 28, label: n }) });
}
export {
  at as AVATAR_PALETTES,
  xa as ContentHeader,
  oa as ContextMenuPrimitive,
  wn as CountBadge,
  Q as DialogPrimitive,
  Ba as DismissableLayerBranch,
  T as DropdownMenuPrimitive,
  ka as DsAvatar,
  La as FieldError,
  ua as FilterButton,
  ha as FilterChips,
  Sa as ICON_TILE_COLORS,
  ga as ListPanel,
  Ln as MATERIAL_GLYPHS,
  ma as NavRail,
  ba as NavRailItem,
  pa as NavRailLogo,
  Ma as PhoneHQActionDialog,
  it as PhoneHQAvatar,
  ze as PhoneHQButton,
  wa as PhoneHQCheckbox,
  Ya as PhoneHQCombobox,
  Oa as PhoneHQConfirmDialog,
  Ta as PhoneHQDatepicker,
  Ca as PhoneHQDialog,
  _a as PhoneHQDialogFooter,
  De as PhoneHQDropdown,
  Tn as PhoneHQGlyph,
  Da as PhoneHQIconAvatar,
  Na as PhoneHQInput,
  Ea as PhoneHQLoader,
  Ee as PhoneHQModal,
  Re as PhoneHQPopover,
  ja as PhoneHQRadioCards,
  Fa as PhoneHQRadioRow,
  Ia as PhoneHQSelect,
  $a as PhoneHQSortHeader,
  Zn as PhoneHQSpinner,
  Ha as PhoneHQSwitch,
  Pa as PhoneHQTabs,
  Wa as PhoneHQToast,
  Aa as PhoneHQTooltip,
  j as PopoverPrimitive,
  Mt as RadioDot,
  yn as SKELETON_DELAY_MS,
  ya as SearchField,
  va as Segmented,
  fe as SkeletonBlock,
  ca as SkeletonList,
  da as SkeletonTable,
  za as StackedAvatars,
  jn as Status,
  fa as StatusBadge,
  ge as TooltipPrimitive,
  Ye as avatarVariants,
  _n as buttonVariants,
  Yn as fallbackVariants,
  On as initialsOf,
  ve as menuContentClass,
  ye as menuItemClass,
  zn as navRailItemClass,
  We as paletteForName,
  In as statusVariants,
  Rn as tabsListVariants,
  Vn as tabsTriggerVariants,
  Wn as tileForColorKey,
  la as useDelayedFlag
};
//# sourceMappingURL=index.es.js.map
